import React, { Component } from 'react';

export const grupacije = [
    { key: '0', value: '0', text: 'Sve grupacije' },
    {
        key: '1', value: '1', text: 'Grupacija umjetnosti', name: 'Umjetnost'
    },
    {
        key: '2', value: '2', text: 'Grupacija društvenih nauka', name: 'Društvene nauke'
    },
    {
        key: '3', value: '3', text: 'Grupacija medicinskih nauka', name: 'Medicinske nauke'
    },
    {
        key: '4', value: '4', text: 'Grupacija prirodno-matematičkih i biotehničkih nauka', name: 'Prirodno-matematičke i biotehničke nauke'
    },
    {
        key: '5', value: '5', text: 'Grupacija tehničkih nauka', name: 'Tehničke nauke'
    },
    {
        key: '6', value: '6', text: 'Grupacija humanističkih nauka', name: 'Humanističke nauke'
    },
    {
        key: '7', value: '7', text: 'UNSA', name: 'UNSA'
    }
];
export const ciklusi = [
    {
        key: '0', value: '0', text: 'Svi', name: ''
    },
    {
        key: '1', value: '1', text: 'I ciklus studija', name: 'I'
    },
    {
        key: '2', value: '2', text: 'II ciklus studija', name: 'II'
    },
    {
        key: '3', value: '3', text: 'III ciklus studija', name: 'III'
    },
    {
        key: '4', value: '4', text: 'Integrirani studij I i II ciklusa', name: 'Integrirani'
    },
    {
        key: '5', value: '5', text: 'Stručni studij', name: 'Stručni studij'
    },

];

export const fakulteti = [
    {
        key: '0', value: '0', text: 'Svi fakulteti i akademije', name: ''
    },
    { key: '1', value: '1', text: 'Akademija likovnih umjetnosti' },
    { key: '2', value: '2', text: 'Akademija scenskih umjetnosti' },
    { key: '3', value: '3', text: 'Arhitektonski fakultet' },
    { key: '4', value: '4', text: 'Centar za interdisciplinarne studije' },
    { key: '5', value: '5', text: 'Ekonomski fakultet' },
    { key: '6', value: '6', text: 'Elektrotehnički fakultet' },
    { key: '7', value: '7', text: 'Farmaceutski fakultet' },
    { key: '8', value: '8', text: 'Fakultet islamskih nauka' },
    { key: '9', value: '9', text: 'Fakultet političkih nauka' },
    { key: '11', value: '11', text: 'Fakultet sporta i tjelesnog odgoja' },
    { key: '12', value: '12', text: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije' },
    { key: '13', value: '13', text: 'Fakultet za saobraćaj i komunikacije' },
    { key: '14', value: '14', text: 'Fakultet za upravu' },
    { key: '15', value: '15', text: 'Fakultet zdravstvenih studija' },
    { key: '16', value: '16', text: 'Filozofski fakultet' },
    { key: '17', value: '17', text: 'Građevinski fakultet' },
    { key: '18', value: '18', text: 'Katolički bogoslovni fakultet' },
    { key: '19', value: '19', text: 'Mašinski fakultet' },
    { key: '20', value: '20', text: 'Medicinski fakultet' },
    { key: '21', value: '21', text: 'Muzička akademija' },
    { key: '22', value: '22', text: 'Pedagoški fakultet' },
    { key: '23', value: '23', text: 'Poljoprivredno-prehrambeni fakultet' },
    { key: '24', value: '24', text: 'Pravni fakultet' },
    { key: '25', value: '25', text: 'Prirodno-matematički fakultet' },
    { key: '26', value: '26', text: 'Stomatološki fakultet sa klinikama' },
    { key: '27', value: '27', text: 'Šumarski fakultet' },
    { key: '28', value: '28', text: 'Veterinarski fakultet' },

];

export const grupations = [
    { key: '0', value: '0', text: 'All grupations' },
    {
        key: '1', value: '1', text: 'Grupation of arts', name: 'Arts'
    },
    {
        key: '2', value: '2', text: 'Grupation of social sciences', name: 'Social Sciences'
    },
    {
        key: '3', value: '3', text: 'Grupation of medical sciences', name: 'Medical Sciences'
    },
    {
        key: '4', value: '4', text: 'Grupation of natural sciences, mathematics & biotech studies', name: 'Natural Sciences, Mathematics & Biotech Studies'
    },
    {
        key: '5', value: '5', text: 'Grupation of technical sciences', name: 'Technical Sciences'
    },
    {
        key: '6', value: '6', text: 'Grupation of humanities', name: 'Humanities'
    },
    {
        key: '7', value: '7', text: 'UNSA', name: 'UNSA'
    }
];
export const cycles = [
    {
        key: '0', value: '0', text: 'All cycles', name: ''
    },
    {
        key: '1', value: '1', text: 'I cycle', name: 'I'
    },
    {
        key: '2', value: '2', text: 'II cycle', name: 'II'
    },
    {
        key: '3', value: '3', text: 'III cycle', name: 'III'
    },
    {
        key: '4', value: '4', text: 'Integrated study I and II cycles', name: 'Integrated'
    }
];

export const faculties = [
    {
        key: '0', value: '0', text: 'All faculties and academies', name: ''
    },
    { key: '1', value: '1', text: 'Academy of Fine Arts' },
    { key: '2', value: '2', text: 'Academy of Performing Arts' },
    { key: '3', value: '3', text: 'Faculty of Architecture' },
    { key: '4', value: '4', text: 'Center for Interdisciplinary Studies' },
    { key: '5', value: '5', text: 'Faculty of Economics' },
    { key: '6', value: '6', text: 'Faculty of Electrical Engineering' },
    { key: '7', value: '7', text: 'Faculty of Pharmacy' },
    { key: '8', value: '8', text: 'Faculty of Islamic Studies' },
    { key: '9', value: '9', text: 'Faculty of Political Sciences' },
    { key: '11', value: '11', text: 'Faculty of Sports and Physical Education' },
    { key: '12', value: '12', text: 'Faculty of Criminal Justice, Criminology and Security Studies' },
    { key: '13', value: '13', text: 'Faculty of Traffic and Communications' },
    { key: '14', value: '14', text: 'Faculty of Administration' },
    { key: '15', value: '15', text: 'Faculty of Health Studies' },
    { key: '16', value: '16', text: 'Faculty of Philosophy' },
    { key: '17', value: '17', text: 'Faculty of Civil Engineering' },
    { key: '18', value: '18', text: 'Catholic Theological Faculty' },
    { key: '19', value: '19', text: 'Faculty of Mechanical Engineering' },
    { key: '20', value: '20', text: 'Medical Faculty' },
    { key: '21', value: '21', text: 'Academy of Music' },
    { key: '22', value: '22', text: 'Faculty of Educational Sciences' },
    { key: '23', value: '23', text: 'Faculty of Agriculture and Food Sciences' },
    { key: '24', value: '24', text: 'Faculty of Law' },
    { key: '25', value: '25', text: 'Faculty of Science' },
    { key: '26', value: '26', text: 'Faculty of Dentistry of Sarajevo University' },
    { key: '27', value: '27', text: 'Faculty of Forestry' },
    { key: '28', value: '28', text: 'Veterinary Faculty of the University of Sarajevo' },

];

export const studyPrograms =
[
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Economics",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Economics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-3637/08, 29.10.2008./ 01-5853/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Management",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Management",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-3637/08, 29.10.2008./ 01-5853/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Applied Business Programme",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Business",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-3637/08, 29.10.2008./ 01-5853/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "The Study Programme in Cooperation with Griffith College Dublin, Ireland (Sarajevo Business School)",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Management",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-482/09, 25.02.2009./ 01-38-2327/10, 22.09.2010.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/bachelor_in_business_studies_2015_web.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Economics",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Economics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-3637/08, 29.10.2008. 01-I-1501/08, 14.05.2008./ 01-38-1228/10, 28.04.2010. 01-5853/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Management",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Management",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-3637/08, 29.10.2008. 01-I-1501/08, 14.05.2008./ 01-38-1228/10, 28.04.2010. 01-5853/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Twinning Master Programme with Faculty of Economics and Business, University of Zagreb",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Economics/ Management",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60 120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1501/08, 14.05.2008./ 01-38-3730/10, 01.12.2010.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/bs/programi-ii-ciklusa" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Double Degree Master Programme with Faculty of Economics, University of Ljubljana - \"Public Sector and Environmental Economics\"",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Economics / Management",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1397/08, 16.07.2008./ 01-5855/15, 30.09.2015.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ljubljana_-_brosura_0.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Joint Master Programme with University of Bolton Islamic Banking",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Management",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-2083/13, 26.06.2013./ 01- 3679/16, 25.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/islamsko_bankarstvo_-_npp.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Programme with Microsoft",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Management",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60 120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-1457/17, 22.02.2017 01-1507/17, 22.02.2017",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/efsamicrosoftbih-mis.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Economics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Economics",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1502/08, 14.05.2008./ 01-5854/15, 30.09.2015",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/docs/Doktorski%20studij/Doktorski-Course-Catalogue_2012.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Economics",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Management/Business",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Management",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1502/08, 14.05.2008./ 01-5854/15, 30.09.2015",
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/docs/Doktorski%20studij/Doktorski-Course-Catalogue_2012.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "International Relations and Diplomacy",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Political Science \u2013 International Relations and Diplomacy Track",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-624/13, 06.03.2013.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EZlEKhqsM4lPoluBFGOGSnMBUsZKoexwBgizUZpY6dJyvw?e=95rTbm" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "State Management",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Political Science \u2013 State Management Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EelAoqyzh9NOn5ilyWQuPY4B8Edx0t-MkVg5Z81SdoWd7w?e=1yNIqV" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESmzNkM2Em1MsK4cugQv8sgBdzyqCbZp7zGQSfhoqtu2DA?e=krVKNq" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Journalism and Communication Studies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Journalism and Communication Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESQlTioA1zlMvTf6C3e5Qa8Bcq7SWWtr1agKUYFk3aRBmw?e=1FVgrG" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Security and Peace Studies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Security and Peace Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW0pvUZTk8NApYvUbxpkDsoBoebM-PagiKEPtEAbsHLkYg?e=tmhXEW" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Social Work",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Social Work",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESHihufoP6tJjr4UxD30mbsBNBcZw3_FggCacFIHRGP_uQ?e=IUNSl7" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "International Relations and Diplomacy",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Political Science \u2013 International Relations and Diplomacy Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/Edcfa0-6NkhLu32v_L-uz9UBZfZr6xgYufYPVTKflLDWPA?e=Owe6Tg" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "International Relations and Diplomacy",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Political Science \u2013 International Relations and Diplomacy Track",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-624/13, 06.03.2013.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EWvbAi-8xHtIpSQ36CIeRq0BjbdxsrKT9LKdM8F08_lQfg?e=8dt1uc" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "State Management",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Political Science - State Management Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETQePsNFQq9LlM4_pI1TGHEB6KgNnOywsLYmzNba35Iedg?e=Epd2UP" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sociology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EWdgN4ONVJBFpLzqiB9Ns70BYIZx9mgMLH_9PG6NnU-hFw?e=wdu1zE" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Journalism and Communication Studies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Journalism and Communication Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EV52zXMmLYVHuI6ARAAbyRIBASHq_qA4r_eG2OTZ0pc5Bw?e=H8lqId" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Security and Peace Studies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Security and Peace Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETzlvbV8ouNIhsHRu55lKSYBg1zAA-TuAIBI-Kkpa9HWRg?e=btLULf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Social Work",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Social Work",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2705/15, 29.04.2015.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EZ6flL3PWTFElwa3irm_GfIBuiDZXB3eciPKnqgw2mifDw?e=yyTIlW" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Sociology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4464/16, 29.06.2016.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EcLFGKUaNg5Gl-XAmQIsf9QBFb4gH-N9HSEyAkZ8clfFfQ?e=0m8vD2" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Political Science",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Political Science",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4464/16, 29.06.2016.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EcV4FNW8AQNOg-wirbbXo2EBsxGbRR73U_IOK_Y97mPBKw?e=fbbHvc" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Communication Studies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Communication Science",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4464/16, 29.06.2016.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW7bt8Wp-TBOgoOnB8tq1_QBwVgETaQpnoDGgRn-AiR3gQ?e=fA8dwp" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Social Work",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Social Work",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4464/16, 29.06.2016.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETV296wLBwhPsKDL2RiKyrUBf1QeHcar4LWgdhtFljtkag?e=Kc3LDw" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Political Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Security and Peace Studies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Political Science - Security and Peace Studies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4464/16, 29.06.2016.",
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW-e-xWmjYlLm-8qXPwXHh0B0UoJfLIz_JcbfkNqHLRPEQ?e=buyIKV" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Sports and Physical Education",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "General Programme",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sports and Physical Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-991/06",
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-28-42/opci-smjer-240-ects" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Sports and Physical Education",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Management in Sports  Strength and Conditioning",
    NacinRealizacijeNastave: "Part-Time, Distance Learning  Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Management  Bachelor of Strength and Conditioning",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3671/17",
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-28-42/menadzment-u-sportu-180-ects" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Sports and Physical Education",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "General Programme",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sports and Physical Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1540/09",
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-35-57/opci-smjer-60-ects" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Sports and Physical Education",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Management in Sports",
    NacinRealizacijeNastave: "Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Management in Sports",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1540/09",
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-35-57/menadzment-u-sportu-120-ects" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Sports and Physical Education",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Kinesiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Social Sciences / Kinesiology: -Education in Kinesiology -Recreation in Kinesiology -Sport Kinesiology - Kinesiotherapy in Kinesiology -Organisation and Management in Kinesiology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-3159/13  01-8176/17",
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-43-49/doktorski-studij-iz-oblasti-kineziologije" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Criminal Justice",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Criminal Justice",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 22.02.2017.",
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Criminology",
    NacinRealizacijeNastave: "Full-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Criminology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 22.02.2017.",
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Security Studies",
    NacinRealizacijeNastave: "Full- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Security Management",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 22.02.2017.",
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Criminal Justice",
    NacinRealizacijeNastave: "Full- Time, Part-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Criminal Justice",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 30.09.2015.",
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/kriminalistika" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Criminology",
    NacinRealizacijeNastave: "Full- Time, Part-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Criminology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 30.09.2015.",
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/kriminologija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Security Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Security Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013. / 30.09.2015.",
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/sigurnosne-studije" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Crisis Management in The Security Sector",
    NacinRealizacijeNastave: "Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Crisis Management in The Security Sector",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/krizni-menadzment" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Corporate Security and Protection",
    NacinRealizacijeNastave: "Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Corporate Security and Protection",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "26.04.2017. / 25.10.2017.",
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/korporativna-sigurnost" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Criminal Justice",
    NacinRealizacijeNastave: "Full- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Criminal Justice",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "06.03.2013. / 23.12.2015.",
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Criminology",
    NacinRealizacijeNastave: "Full- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Criminoloy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "06.03.2013. / 23.12.2015.",
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Criminal Justice, Criminology and Security Studies",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Security Studies",
    NacinRealizacijeNastave: "Full- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Security Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "06.03.2013. / 23.12.2015.",
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Administration: General Track Business Administration Track E-Government Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.09.2017.",
    LinkNaStudijskiProgram: <a href="http://fu.unsa.ba/studij/ciklusi/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration Faculty of Economics and Business Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "informatics in Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of informatics in Administration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2015.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Administration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.10.2017.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Administration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "15.07.2015.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Administration \u2013 Business Administration Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.06.2014.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Administration \u2013 E-Government Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.06.2014.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Administration",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Administration",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Administration Studies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "06.11.2013.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Law",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Law",
    NacinRealizacijeNastave: "Full- Time, Part- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Law",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-13357/11, 25.05.2011. 01-2704/15, 29.04.2015. 01-555/16, 27.01.2016. 01-3680/16, 25.05.2016. 01-4765/16, 13.07.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/Nastavni-plan-i-program-1.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Law",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Law",
    NacinRealizacijeNastave: "Full- Time, Part- Time, Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Law",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1225/10, 28.04.2010. 01-2704/15, 29.04.2015. 01-555/16, 27.01.2016. 01-3680/16, 25.05.2016. 01-4765/16,13.07.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/Nastavni-plan-i-program-II-ciklusa-studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Social Sciences",
    FakultetAkademija: "Faculty of Law",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Law",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Law",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1716/11, 29.06.2012.",
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/NOVI-DOKTORSKI.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Islamic Theology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Islamic Theology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3678/16, 25. 05. 2016",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-I_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Islamic Religious Education and Religious Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Islamic Religious Education and Religious Pedagogy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3678/16, 25. 05. 2016",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-I_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Study Programme For Imams, Khatibs and Mu'allims",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor in Imama, Khataba and Ta'lim",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-4661/15, 15 07. 2015",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/silabusi/dodiplomski/studij-za-imame-npp.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Islamic Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Islamic Studies (with Track indication)",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3678/16, 25. 05. 2016",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-II_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "interreligious Studies and Peace-Building - Joint Master Studies Programme: Faculty of Islamic Studies (University of Sarajevo), Catholic Theological Faculty (University of Sarajevo), and Orthodox Theological Faculty \u201cSt.Vasilijeostro\u0161ki'' in Fo\u010da, (University of East Sarajevo)",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of interreligious Studies and Peace-Building",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3678/17, 24. 05. 2017",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2018/Elaborat.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Islamic Studies",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Islamic Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Islamic Studies (with Track indication)",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-7902/15, 23. 12.2015",
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/doktorski/doktorske-studije-elaborat.pdf" target="_blank"> LINK </a>
  },{
    GrupacijaNaukaUmjetnosti: 'Humanities',
    FakultetAkademija: 'Faculty of Islamic Studies',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Masters program in Islamic studies “Islam in Europe”',
    NacinRealizacijeNastave: 'Full-Part-time',
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Islamic Studies",
    JezikStudija: 'English',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/index.php/izdvojeno/4713-master-in-islamic-studies" target="_blank"> LINK </a>
},{
    GrupacijaNaukaUmjetnosti: 'Humanities',
    FakultetAkademija: 'Faculty of Islamic Studies',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master Program for Imams',
    NacinRealizacijeNastave: 'Full-Part-time',
    NazivKvalifikacijeIOdgovarajucaTitula: "Mastzer for Imams",
    JezikStudija: 'Bosnian, Croatian and Serbian',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2018/elaborat-master-imami.pdf" target="_blank"> LINK </a>
},
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, Serbian, and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, Serbian, and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and German Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, English and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "English Language and Literature and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of English Language and Literature and Pedagogy",
    JezikStudija: "Bosnian, Croatian, Serbian, and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div> <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram:<div> <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and German Language and Literature",
    JezikStudija: "Bosnian, Croatian, and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Bosnian, Croatian and Serbian Language and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy and Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy and Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy and German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy and German Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Philosophy and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Philosophy and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, German and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, German and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, German and Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, German and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian, German and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, Serbian and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "German Language and Literature and The Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of German Language and Literature and The Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian, German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History and Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History and Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08, 30. 06., 2008; 01-I-1508/0, 14. 05. 2008; 01-I-1509/08, 14. 05. 2008. 02-01/163, 21. 06. 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a> {'  |  '} <a href="" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History and Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History and Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08, 30. 06., 2008; 01-I-1508/0, 14. 05. 2008; 01-I-1509/08, 14. 05. 2008. 02-01/163, 21. 06. 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156, 15.06. 2005 02-01/177, 27. 09. 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and The Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and The Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Philosophy",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and History",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "History of Art and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of History of Art and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; No. 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Archeology and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Archeology and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; No. 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. .02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Archeology and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Archeology and History",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Archeology and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Archeology and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Archeology and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Archeology and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina and Bosnian, Croatian and Serbian Language \u2013 Teaching Track",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Literatures of The Peoples of Bosnia and Herzegovina and Bosnian, Croatian and Serbian Language \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Literatures of The Peoples of Bosnia and Herzegovina and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Literatures of The Peoples of Bosnia and Herzegovina and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, Serbian and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and Library Studiess",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Comparative Literature and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Comparative Literature and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Library Studies and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Library Studies and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Library Studies and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Library Studies and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Library Studies and German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Library Studies and German Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Library Studies and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Library Studies and History",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Persian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Persian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Persian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian Arabic and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and Persian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and Persian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic and Persian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Arabic Language and Literature and Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Arabic Language and Literature and Philosophy",
    JezikStudija: "Bosnian, Croatian, and Serbian, Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Persian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Persian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and Persian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Turkish Language and Literature and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Turkish Language and Literature and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Turkish and Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Persian Language and Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Persian Language and Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Persian and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Persian Language and Literature and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Persian Language and Literature and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Persian and Arabic",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Persian Language and Literature Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Persian Language and Literature and Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian, Persian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Persian Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Persian Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Persian and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Special Pedagogies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Special Pedagogies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-7195/15 of Nov 26, 2015 02-01/413 of 1.712.2015. 02-01/405 of Nov 11, 2015",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005  02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and Philosophy",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 30, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008; 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Pedagogy and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Pedagogy and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Psychology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Psychology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-46-21" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Philosophy",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French and Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and German Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French and German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "French Language and Literature and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of French Language and Literature and Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and The History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and The History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and Latin Language and Roman Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and Latin Language and Roman Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian and Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Italian Language and Literature and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Italian Language and Literature and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin and Italian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and Pedagogy",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and History",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin and Turkish",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and Bosnian, Croatian and Serbian Language",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and History",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Latin Language and Roman Literature and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Latin and French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Russian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Russian Language and Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Russian Language and Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian, Russian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Russian Language and Literature and English Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Russian Language and Literature and English Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, Russian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Socioly and Ethology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and Ethology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-7199/15 of Nov 26, 2015 02-01/422 of Dec 1, 2015 02-01/418 of Nov 11, 2015",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian, French",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology and History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and History of Art",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sociology and Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sociology and Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "English Language and Literature \u2013",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of English Language and Literature \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "English Language and Literature \u2013 Translation and interpreting",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of English Language and Literature \u2013 Translation and interpreting Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "English Language and Literature \u2013 Linguistics",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of English Language and Literature \u2013 Linguistics Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "English Language and Literature \u2013 Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of English Language and Literature \u2013 Literature Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language \u2013 Lector",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Bosnian, Croatian and Serbian Language \u2013 Lector Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Literature of Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Bosnian, Croatian and Serbian Language and Literature of The Peoples of Bosnia and Herzegovina \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Bosnian, Croatian and Serbian Language and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Bosnian, Croatian and Serbian Language and French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Bosnian, Croatian and Serbian Language and French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and French",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Philosophy \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Philosophy - Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of German Language and Literature \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and German",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "German Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of German Language and Literature \u2013 Literature Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and German",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History (Ancient History)",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History - Research Track (Ancient History)",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "Consent of The Senate of UNSA No. 02-01/156 of July 15, 2005 Decision of The Faculty Board To Adopt The Curriculum No. 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History (Modern Age)",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History - Research Track (Modern Age)",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History \u2013 Teaching Track and Pedagogy \u2013 Professional Track  Master of History \u2013 Teaching Track and Pedagogy- Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 18, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Modern and Contemporary Art and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Modern and Contemporary Art \u2013 Research Track and Pedagogy \u2013 Professional Track Master of History of Art \u2013 Modern and Contemporary Art \u2013 Research Track and Pedagogy \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918- Research Track and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918- Teaching Track and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918- Teaching Track and Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 and History",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918- Teaching Course and History: Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918- Research Track and of Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Turkish",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Modern and Contemporary Art and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Modern and Contemporary Art \u2013 Research Track and of Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "History of Art \u2013 Modern and Contemporary Art and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of History of Art \u2013 Modern and Contemporary Art \u2013 Research Track and of Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Archeology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Archeology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 31, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Archeology and History of Art (Modern and Contemporary Art)",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Archeology and History of Art: Modern and Contemporary Art \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 31, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Archeology and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Archeology and of Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-293/08 of Jan 31, 2008; 01-I-1506/08. of May 14, 2008; 01-I-1508/08 of May 14, 2008 01-I-1509/08 of May 14, 2008. 02-01/163 of June 21, 2008",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>   <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina \u2013 Scientific Course",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina and Bosnian, Croatian and Serbian Language",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Literatures of The Peoples of Bosnia and Herzegovina and Bosnian, Croatian and Serbian Language \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bosnia and Herzegovina and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Literatures of The Peoples of Bosnia and Herzegovina and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Comparative Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Comparative Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Library Studies and Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Library Studies and Pedagogy \u2013 Professional Track Master of Library Studies and Pedagogy \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Library Studies and History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Library Studies and History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Library Studies and Literatures of The Peoples of Bosnia and Herzegovina",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Library Studies and Literatures of The Peoples of Bosnia and Herzegovina",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Comparative Literature and History of Art \u2013 Modern and Contemporary Art",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Comparative Literature and History of Art \u2013 Modern and Contemporary Art \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Comparative Literature and History of Art \u2013 Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Comparative Literature and History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Arabic",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Turkish",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Persian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Persian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Persian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Turkish Language and Literature and Arabic Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Turkish Language and Literature and Arabic Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Turkish and Arabic",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Turkish Language and Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Turkish Language and Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Turkish and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Arabic Language and Literature and Turkish Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Arabic Language and Literature and Turkish Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Arabic and Turkish",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Pedagogy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Pedagogy \u2013 Professional Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Pedagogy and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Pedagogy \u2013 Professional Track and Library Studies  Master of Pedagogy \u2013 Research Track and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Psychology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Psychology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-46-21" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "French Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of French Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and French",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Italian Language and Literature and History of Art (Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918)",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Italian Language and Literature and History of Art: Art in The Territory of Bosnia and Herzegovina From 15th Century To 1918 \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "French Language and Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of French Language and Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and French and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "French Language and Literature and Latin Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of French Language and Literature and Latin Language with Roman Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and French and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Italian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Latin Language and Roman Literature and Italian Language and Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Latin and Italian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Latin Language and Roman Literature and Comparative Literature",
    JezikStudija: "Bosnian, Croatian, and Serbian and Latin",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Latin Language and Roman Literature and Library Studies",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Latin Language and Roman Literature and Library Studies",
    JezikStudija: "Bosnian, Croatian, and Serbian and Latin",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Russian Language and Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Russian Language and Literature \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian and Russian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sociology \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sociology \u2013 Research Track",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sociology",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sociology",
    JezikStudija: "Bosnian, Croatian, and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "02-01/156 of July 15, 2005 02-01/177 of Sept 27, 2005",
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Sociology, Contemporary Sociology and Globalization Processes",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Sociology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-2315/10 of Sept 22, 2010",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Contemporary Philosophy",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Philosophy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-3684/11 of Dec 28, 2011 01-4518/17 of June 27, 2017",
    LinkNaStudijskiProgram: "  "
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy/ Department of Literatures of Peoples of Bosnia and Herzegovina",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Literatures of The Peoples of Bih",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Literature and History \u2013 Literatures of The Peoples of Bih",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1975/12 of July 18, 2012 01-4514/17 of June 27, 2012",
    LinkNaStudijskiProgram: " "
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Psychology",
    NacinRealizacijeNastave: "Full- Time,",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Psychology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-3684-1/11 of Dec 28, 2011 0101-38-2380/13 of July 17, 2013",
    LinkNaStudijskiProgram: " "
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "History (Tracks: The Area of Bosnia and Herzegovina in The Context of Ancient Europe and The Mediterranean, History of Medieval Bosnia and Herzegovina in The Ottoman Period (1463-1839), History of Bosnia and Herzegovina in The 19th and 20th Century)",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in History",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-767/11 of March 30, 2011",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "German Language and Literature in The Context of Media Culture",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Literature / PhD in Linguistics (with Track indication)",
    JezikStudija: "Bosnian, Croatian and Serbian, German",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-767/11 of March 30, 2011",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Linguistics",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Linguistics (Tracks: : English Language, Bosnian, Croatian and Serbian Language German Language Arabic Language Turkish Language French Language Italian Language Russian Language",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-34-265/12 of April 25, 2012",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Doctoral Program of Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Literature (Corresponding Field/Branch) Literatures in English (English, British, American, Postcolonial Literature) German Literature Theory of Literature Arabic Literature Turkish Literature (Literature in Contemporary and Ottoman Turkish Language) Persian Literature French Literature Roman Literature (Literatures in Latin Language) Slavic /Russian Literature",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-997/13 of April 3, 2013",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Comparative Literature",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Literature \u2013 Comparative Literature",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1673/13 of April 24, 2013 01-4465/16 of June 29, 2016 01-6081/17 of Sept 27, 2017",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Philosophy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Pedagogy \u2013 Theories and Research in Creative Development and Education",
    NacinRealizacijeNastave: "Full- Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Upbringing Sciences and Pedagogy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "1-38-1828/14 of May 7, 2014",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Catholic Theological Faculty",
    CiklusStudija: "integrated Cycle",
    NazivStudijskogPrograma: "Philosophy - Theology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Theology",
    JezikStudija: "Croatian",
    TrajanjeCiklusaStudijaECTS: "300",
    DatumSaglasnostiZaIzvodjenjeStudija: "28. 9. 2016.",
    LinkNaStudijskiProgram: <a href="http://kbf.ba/page.php?id=338" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Catholic Theological Faculty",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "interreligious Peacebuilding",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master in interreligious Peacebuilding",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "24. 5. 2017.",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Preschool Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Preschool Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1705/09, 08.07.2009./ 01-38-485-1/11, 23.02.2011.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/programi%20PO%20PF%206-4-11.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Elementary School Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Elementary School Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1705/09, 08.07.2009./ 01-38-485-1/11, 23.02.2011.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/programi%20RN%20%20PF%206-4-11.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Culture of Living and Technical Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Culture of Living and Technical Education with informatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-3206-4/09, 23.12.2009.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/KZTO%20sa%20informatikom.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Education and Rehabilitation",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Education and Rehabilitation",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3766/16, 25.05.2016. 11-05-38-565-3/16, 31.10.2016.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/NPP_edukacija_rehabilitacija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Preschool Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Preschool Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1705/09, 08.07.2009.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/PO_5_godina.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Elementary School Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Elementary School Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1705/09, 08.07.2009.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/RN_5_godina.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Culture of Living and Technical Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Culture of Living and Technical Education with informatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1705/09, 08.07.2009./ 01-5052/17, 19.07.2017.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/KZTO_diplomski_5_godina.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Education and Rehabilitation",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Education and Rehabilitation",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3766/16, 25.05.2016. / 11-05-38-565-3/16 31.10.2016.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/NPP_edukacija_rehabilitacija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Humanities",
    FakultetAkademija: "Faculty of Educational Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Contemporary Courses of Preschool and Elementary School Education",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Educational Sciences Tracks: The Methodology of Bosnian, Croatian, Serbian Language and Literature in Initial Elementary School Education  The Methodology of Mathematics in Initial Elementary School Education  The Methodology of Nature and Society in Initial Elementary School Education  The Methodology of Culture of Living in Initial Elementary School Education  The Methodology of Music Education in Initial Elementary School Education  The Methodology of Arts Education in Initial Elementary School Education  The Methodology of Technical Education with informatics in Initial Elementary School Education  The Methodology of Physical Education in Initial Elementary School Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-3134/12, 27.12.2012./ 01-38-621/13, 06.03.2013./ 01-5051/17, 19.07.2017.",
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/20180115_NPP_III_ciklus.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Physical Therapy",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Physical Therapy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 04/06/2014",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/fizikalna-terapija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Laboratory Technologies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Laboratory Technologies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 04/06/2014",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/laboratorijske-tehnologije" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Radiological Technologies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Radiology Technologies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 04/06/2014",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/radioloske-tehnologije" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sanitary Engineering",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Sanitation Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 04/06/2014",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/sanitarno-inzinjerstvo" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Healthcare",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Healthcare",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 04/06/2014",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/zdravstvena-njega" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Physical Therapy",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Physical Therapy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 29/05/2013 28/01/2015",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/fizikalna-terapija" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Laboratory Technologies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Laboratory Technologies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 29/05/2013 28/01/2015",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/laboratorijske-tehnologije" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Radiological Technologies",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Radiology Technologies",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 29/05/2013 28/01/2015",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/radioloske-tehnologije" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sanitary Engineering",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Sanitation Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 29/05/2013 28/01/2015",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/sanitarno-inzinjerstvo" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Health Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Healthcare",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Healthcare",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "29/04/2009 29/05/2013 28/01/2015",
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/zdravstvena-njega" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Pharmacy",
    CiklusStudija: "integrated Studies",
    NazivStudijskogPrograma: "Pharmacy",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Pharmacy - Professional Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "300",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-3502/15, 27.05.2015.",
    LinkNaStudijskiProgram: <a href="https://ffsa.unsa.ba/wp-content/uploads/2017/12/Nastavni-plan-i-program-ECTS-katalog-2015.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Pharmacy",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Pharmaceutical Research",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Pharmaceutical Sciences",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "2013",
    LinkNaStudijskiProgram: <a href="https://ffsa.unsa.ba/wp-content/uploads/2014/03/NASTAVNI-PLAN-I-PROGRAM-III-CIKLUSA-Farmaceutska-istra%C5%BEivanja-1.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Medical Faculty",
    CiklusStudija: "integrated Study of \u201cMedicine\u201d (I and II Cycle)",
    NazivStudijskogPrograma: "Medicine",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Medical Doctor",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "360",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2015.",
    LinkNaStudijskiProgram: <a href="http://www.mf.unsa.ba/index.php/studijski-programi-i-edukacija/dodiplomski-studij" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Medical Faculty",
    CiklusStudija: "integrated Undergraduate / Graduate Degree Programme \u201cMedical Studies in English Language\u201d (I and II Cycle)",
    NazivStudijskogPrograma: "Medicine",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Medical Doctor",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "360",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.02.2015.",
    LinkNaStudijskiProgram: <a href="http://en.mf.unsa.ba/data/Nastavni_plan_i_program_na_engleskom_jeziku.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Medical Faculty",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Biomedicine and Health",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Medicine",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "26.06.2013.",
    LinkNaStudijskiProgram: <a href="http://mf.unsa.ba/podaci/dokumenti/doktorski/Reformisani_Curriculum_doktorskog_studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Dentistry of Sarajevo University",
    CiklusStudija: "integrated Studies of I and II Cycle",
    NazivStudijskogPrograma: "Dental Medicine",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Dental Medicine",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "360",
    DatumSaglasnostiZaIzvodjenjeStudija: "13.07.2017. Years",
    LinkNaStudijskiProgram: <a href="http://sf.unsa.ba/bs/bolonjski-studij/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Faculty of Dentistry of Sarajevo University",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Dental Medicine",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Phd in Dental Medicine",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "19.07.2017. Years",
    LinkNaStudijskiProgram: <a href="http://sf.unsa.ba/bs/studij-i-programi/doktorski/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Medical Sciences",
    FakultetAkademija: "Veterinary Faculty of the University of Sarajevo",
    CiklusStudija: "integrated Study of The I and II Cycle",
    NazivStudijskogPrograma: "Veterinary Medicine",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Veterinary Medicine",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "300",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.09.2013.",
    LinkNaStudijskiProgram: <a href="http://vfs.unsa.ba/student/VFS_stud_vodic_BOS_2018_ver_17012018.pdf" target="_blank"> LINK </a>
  },
    {
        GrupacijaNaukaUmjetnosti: "Medical Sciences",
        FakultetAkademija: "Veterinary Faculty of the University of Sarajevo",
        CiklusStudija: "III",
        NazivStudijskogPrograma: "Veterinary Medicine and Public Health",
        NacinRealizacijeNastave: "Full-Time",
        NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Veterinary Science",
        JezikStudija: "Bosnian, Croatian and Serbian",
        TrajanjeCiklusaStudijaECTS: "180",
        DatumSaglasnostiZaIzvodjenjeStudija: "25.09.2013.",
        LinkNaStudijskiProgram: <a href="http://vfs.unsa.ba/web/index.php/nastava/doktorski-studij/opce-informacije" target="_blank"> LINK </a>
    },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Field Crops and Vegetables Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20RATARSTVO%20i%20POVRTLARSTVO_%20odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Fruit Growing and Viticulture",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20VOCARSTVO%20i%20VINOGRADARSTVO_odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Animal Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Zootechnics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20programi%20ANIMALNA%20PROIZVODNJA-AKVAKULTURA-%20odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Aquaculture",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Zootechnics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20programi%20ANIMALNA%20PROIZVODNJA-AKVAKULTURA-%20odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Food Technology",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Food Technology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE_odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Economics of Agro-industry",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Agricultural Economics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1687-1/05, 26/10/2005",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20EKONOMIKA%20AGROINDUSTRIJE_odsjek%20Ekonomika%20poljoprivrede%20i%20prehrambene%20industrije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sustainable Management of Land and Rural Areas",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20ODRZIVO%20UPRAVLJANJE%20ZEMLJISTEM%20I%20RURALNIM%20PROSTOROM-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Phytomedicine",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20FITOMEDICINA-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Field Crops Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20RATARSTVO-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Vegetables Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20POVRTLARSTVO-II%20ciklus%20studija-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Fruit Growing",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20VOCARSTVO-II%20ciklus-odsjek%20Biljna%20PROIZVODNJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Floristry and Landscape Design",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20FLORISTIKA%20I%20PEJZASNO%20OBLIKOVANJE-II%20ciklus%20studija-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Viticulture and Wine Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Plant Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/studijskiprogramIICIKLUS.php" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Economics of Agro-industry",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Agricultural Economics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20EKONOMIKA%20AGROINDUSTRIJE-II%20ciklus-odsjek%20Ekonomika%20poljoprivrede%20i%20prehrambene%20industrije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Animal Production",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Animal Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20ANIMALNA%20PROIZVODNJA-II%20ciklus%20studija-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Feed and Animal Feeding",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Animal Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20HRANA%20I%20ISHRANAZIVOTINJA-II%20ciklus%20studija-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Aquaculture",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Animal Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20AKVAKULTURA-II%20ciklus-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Quality Control of Food and Beverages",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Food Technology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20KONTROLA%20KVALITETA%20HRANE%20I%20PICA-II%20ciklus%20studija-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Technology of Animal Origin Food",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Food Technology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE%20ANIMALNOG%20PORIJEKLA-II%20ciklus-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Technology of Plant Origin Food",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Food Technology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-I-1513/08, 14/05/2008.",
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE%20BILJNOG%20PORIJEKLA-II%20ciklus-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Agricultural Sciences",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Agricultural Sciences",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-259/11, 26/01/2011",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Agriculture and Food Sciences",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Food Sciences",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Food Sciences",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-259/11, 26/01/2011",
    LinkNaStudijskiProgram: ""
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Biology \u2013 Biochemistry and Physiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Biology \u2013 Track Biochemistry and Physiology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/biohemija-i-fiziologija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Biology - Ecology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Biology \u2013 Track Ecology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/ekologija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Biology - Genetics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Biology \u2013 Track Genetics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. .01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/genetika" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Biology - Microbiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Biology \u2013 Track Microbiology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/mikrobiologija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Biology - Education",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Biology \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/nastavnicki" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Physics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Science in Physics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/I%20ciklus%20Opci%20smjer_41%20_F_.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Physics education",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Science in Physics Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/I%20ciklus%20Fizika%20u%20obrazovanju_41%20_F_.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Physics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Physics - Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Geography",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Geography \u2013 Teaching Tack",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-nastavnicki/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Geography - Regional and Spatial Planning",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Geography - Regional and Spatial Planning Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-regionalno-i-prostorno-planiranje" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Geography - Tourism and Environmental Protection",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Geography \u2013 Tourism and Environmental Protection Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.04.2013",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-turizam-i-zastita-zivotne-sredine/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Chemistry",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Chemistry - General Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.04.2013 24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/opsti-smjer/9-uncategorised/780-inovirani-plan-i-program-i-ciklus-opsti-smjer-2" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Chemistry",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Chemistry \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.04.2013 24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/nastavnicki-smjer/9-uncategorised/781-inovirani-plan-i-program-nastavnicki-smjer-i-ciklus-2" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Chemistry \u2013 Quality Control and Environment Protection",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Chemistry \u2013 Quality Control and Environment Protection Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.04.2013. 24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/kontrola-kvaliteta-i-zastita-okolisa/9-uncategorised/782-plan-i-program-kontrola-kvaliteta-i-zastita-okolisa-i-ciklus-2" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mathematics \u2013 Pure Mathematics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mathematics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/teorijska-matematika.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mathematics \u2013 Mathematics Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mathematics \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/matematika-nastavni-smjer.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mathematics \u2013 Mathematics and informatics Education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mathematics \u2013 Mathematics and informatics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/matematika-i-informatika-nastavni-smjer.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mathematics \u2013 Theoretical Computer Science",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mathematics \u2013 Software Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/teorijska-kompjuterska-nauka.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mathematics \u2013 Applied Mathematics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mathematics \u2013 Applied Mathematics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/primijenjena-matematika.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "interdisciplinary Study Conservation-Restoration",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Conservation and Restoration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013.",
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Biology - Biochemistry and Physiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Biology - Biochemistry and Physiology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/biohemija-i-fiziologija" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Biology - Ecology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Biology \u2013 Ecology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/ekologija" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Biology - Genetics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Biology \u2013 Genetics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/genetika" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Biology - Microbiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Biology \u2013 Microbiology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/mikrobiologija" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Biology - Education",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Biology \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 09.06.2016. 01-4474/16.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/nastavnicki" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Physics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Science in Physics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <div><a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Teorijska_fizika_41_F_.pdf" target="_blank"> LINK </a> {'  |  '} <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Medicinska%20radijaciona%20fizika_41_F_.pdf" target="_blank"> LINK </a> {'  |  '} <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Eksperimentalna%20fizika_41_F_.pdf" target="_blank"> LINK </a></div>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Physics education",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Science in Physics Education",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus%20-Fizika%20u%20obrazovanju_41_F_.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Physics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Physics -  Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Geography",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Geography \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/ii-ciklus-studija/nastavni-programi-ii-ciklusa/smjer-nastavnicki/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Geography - Regional and Spatial Planning",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Geography - Regional and Spatial Planning Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/ii-ciklus-studija/nastavni-programi-ii-ciklusa/smjer-regionalno-i-prostorno-planiranje/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Geography - Tourism and Environmental Protection",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Geography - Tourism and Environmental Protection Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/wp-content/uploads//NastavniplanoviIIciklus/Nastavni_plan_II_ciklus_turizam_i_zastita_zivotne_sredine.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Chemistry",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Chemistry",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2009. 14.06.2012. 29.06.2016. 24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/opsti-smjer" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Chemistry",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Chemistry \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2009. 14.06.2012. 29.06.2016. 24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/nastavnicki-smjer" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Chemistry \u2013 Quality Control and Environment Protection",
    NacinRealizacijeNastave: "Full Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Chemistry- Quality Control and Environment Protection Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/kkzo" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "interdisciplinary Study with AFA and Faculty of Architecture/ Conservation-Restoration",
    NacinRealizacijeNastave: "Full- Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Conservation-Restoration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.05.2017.",
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Mathematics \u2013 Pure Mathematics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mathematics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/opci-smjer.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Mathematics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mathematics \u2013 Mathematics Education Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/nastavnicki-smjer.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Mathematics \u2013 Theoretical Computer Science",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mathematics - Software Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/teorijska-kompjuterska-nauka.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Mathematics \u2013 Applied Mathematics",
    NacinRealizacijeNastave: "Full-Time, Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mathematics - Applied Mathematics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.09.2005. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/primijenjena-matematika.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Biology - Biochemistry and Physiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biology- Biochemistry and Physiology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "10.07.2012. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Biology - Ecology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biology- Ecology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "10.07.2012. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Biology - Genetics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biology \u2013 Genetics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "10.07.2012. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Biology - Microbiology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biology - Microbiology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "10.07.2012. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Joint Doctoral Study of Natural and Mathematical Science in Education -Biology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biology - Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "Sept.2013.. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/prirodne-i-matematicke-nauke-u-obrazovanju" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Psyhics \u2013 Theoretical Psyhics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Physics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.04.2013. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/IIIciklus/teorijska_fizika/Studijski%20program%20III%20CIKLUSA%20STUDIJA%20FIZIKE1.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Joint Doctoral Study of Natural and Mathematical Science in Education - Psyhics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Physics \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "Sept.2013.. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/index.php/bs/treci-ciklus" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Geography - Regional and Spatial Planning",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in - Regional and Spatial Planning Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.04.2013. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/iii-ciklus-studija/nastavni-programi/smjer-regionalno-i-prostorno-planiranje/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Geography - Tourism and Environmental Protection",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Geography - Tourism and Environmental Protection Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.04.2013. 27.01.2016.",
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/iii-ciklus-studija/nastavni-programi/smjer-turizam-i-zastita-zivotne-sredine/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Joint Doctoral Study of Natural and Mathematical Science in Education - Geography",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Geography \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "Sept.2013.. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/geografija/index.php/nastavniplanovipmfunsaiiiciklus/geografija-u-obrazovanju" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Joint Doctoral Study of Natural and Mathematical Science in Education - Chemistry",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Chemistry \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "Sept.2013. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/prirodne-i-matematicke-nauke-u-obrazovanju" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Chemistry",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Chemistry",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "10.07.2012. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/hemija" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "SEE Doctoral Studies in Mathematical Sciences\u2013 Pure Mathematics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mathematics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01.12.2010. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "SEE Doctoral Studies in Mathematical Sciences \u2013Applied Mathematics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mathematics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01.12.2010. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "SEE Doctoral Studies in Mathematical Sciences \u2013 TheoreticalComputer Science",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Computer Science",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01.12.2010. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Science",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Joint Doctoral Study of Natural and Mathematical Science in Education - Mathematics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mathematics \u2013 Teaching Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01.12.2010. 04.05.2016.",
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/prirodne-i-matematicke-nauke-u-obrazovanju.html" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Forestry",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Forestry",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bakalaureat/Bachelor of Forestry",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2398/17, 29. 03. 2017.",
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20I%20ciklus/I%20ciklus%20sumarstvo%2020172018.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Forestry",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Horticulture",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bakalaureat/Bachelor of Horticulture",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-5053/17, 19. 07. 2017.",
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20I%20ciklus/I%20ciklus%20hortikultura%2020172018.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Forestry",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sustainable Management of Forest Ecosystems",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Forestry",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-2398/17, 29. 03. 2017.",
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20II%20ciklus/IIcik20172018sumarstvo.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Forestry",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Landscape Architecture",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Mater of Horticulture",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-5053/17, 19. 07. 2017.",
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20II%20ciklus/IIcik20172018hortikultura.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Natural Sciences, Mathematics & Biotech Studies",
    FakultetAkademija: "Faculty of Forestry",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Forestry and Horticulture",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Biotehnological Science/ Forestry PhD in Biotehnological Science /Horticulture",
    JezikStudija: "Bosnian, Croatian and Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "0101-38-2379/13, 17. 07. 2013.",
    LinkNaStudijskiProgram: " "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Architecture",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Architecture and Urbanism",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Architectural Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-6077/17, 27/09/2017.",
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-i-ciklus.php" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Architecture",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Architecture and Urbanism",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Architectural Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-6078/17, 27/09/2017.",
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-ii-ciklus.php" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Architecture",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Architecture and Urbanism",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Architecture and Urban Planning and Development",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "01-8165/17, 29.11.2017.",
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-iii-ciklus.php" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Automatic Control and Electronics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Electrical Engineering, Automatic Control and Electronics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005. 21.06.2006. 19.09.2007. 25.03.2009. 23.09.2009. 25.06.2014. 25.03.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Electrical Power Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Electrical Engineering, Electrical Power Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005. 21.06.2006. 19.09.2007. 25.03.2009. 23.09.2009. 25.06.2014. 25.03.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Computing and informatics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Electrical Engineering, Computing and informatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005. 21.06.2006. 19.09.2007. 25.03.2009. 23.09.2009. 25.06.2014. 25.03.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Telecommunication",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Electrical Engineering, Telecommunication",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005. 21.06.2006. 19.09.2007. 25.03.2009. 23.09.2009. 25.06.2014. 25.03.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Automatic Control and Electronics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Electrical Engineering, Automatic Control and Electronics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.07.2007. 23.09.2009.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Electrical Power Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Electrical Engineering, Electrical Power Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.07.2007. 23.09.2009.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Computing and informatics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Electrical Engineering, Computing and informatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.07.2007. 23.09.2009.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Telecommunication",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Electrical Engineering, Telecommunication",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.07.2007. 23.09.2009.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Software Engineering",
    NacinRealizacijeNastave: "Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Computing and informatics \u2013 Software Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "28.12.2016. 19.07.2017.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Automatic Control and Electronics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Automatic Control and Electronics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2010. 25.02.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Electrical Power Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in  Electrical Power Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2010. 25.02.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Computing and informatics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in  Computing and informatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2010. 25.02.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Electrical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Telecommunication",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in  Telecommunications",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2010. 25.02.2015.",
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Traffic, Major in Road Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Road Traffic Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2009.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Traffic, Major in Railway Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Railway Traffic Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2009.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Traffic, Major in Air Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Air Traffic Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2009.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Communications, Major in Communication Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Communication Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2009.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Communications, Major in Postal Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Postal Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.05.2009.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Communications, Major in Computer and information Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Traffic and Communications, Computer and information Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.03.2015.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Traffic, Major in Road Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering Road Traffic Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Traffic, Major in Railway Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering, Railway Traffic",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Traffic, Major in Air Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering, Air Traffic Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Communications, Major in Communication Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering, Communication Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Communications, Major in Postal Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering, Postal Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Communications, Major in Computer and information Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Traffic and Communications Engineering, Computer and information Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "04.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Road Traffic",
    NacinRealizacijeNastave: "Full-Time",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.07.2011.",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Traffic and Communications, Road",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Railway Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Traffic and Communications",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.07.2011.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Air Traffic",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Traffic and Communications",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.07.2011.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Communication Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Traffic and Communications",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.07.2011.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Traffic and Communications",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Postal Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Traffic and Communications",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "20.07.2011.",
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Civil Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Civil Engineering \u2013 Civil Engineer Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 03.04.2013. 16.07.2014",
    LinkNaStudijskiProgram: <a href="http://www.gf.unsa.ba/?lokacija=nastava" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Geodesy and Geoinformatics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Geodesy and Geoinformatics \u2013Geodesy and Geoinformatics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 03.04.2013. 16.07.2014.",
    LinkNaStudijskiProgram: " "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Civil Engineering \u2013 Structures",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Civil Engineering \u2013, Field Structures Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 16.07.2014.",
    LinkNaStudijskiProgram: " "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Civil Engineering \u2013 Hydraulic and Environmental Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Civil Engineering \u2013Hydraulic and Environmental Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 03.04.2013. 16.07.2014. 04.05.2016.",
    LinkNaStudijskiProgram: "   "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Civil Engineering \u2013 Transportation",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Civil Engineering \u2013Transportation Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 16.07.2014.",
    LinkNaStudijskiProgram: "  "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Civil Engineering \u2013 Geodesy and Geoinformatics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Geodesy and Geoinformatics \u2013 Geodesy and Geoinformatics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "21.06.2006. 08.07.2009. 03.04.2013. 16.07.2014.",
    LinkNaStudijskiProgram: "    "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Civil Engineering",
    NacinRealizacijeNastave: "Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Civil Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2009. 29.05.2013. 04.05.2016.",
    LinkNaStudijskiProgram: "   "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Civil Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Geodesy and Geoinformatics",
    NacinRealizacijeNastave: "Part-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Geodesy and Geoinformatics",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2009. 29.05.2013. 30.09.2015. 27.09.2017.",
    LinkNaStudijskiProgram: "   "
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mechanical Production Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Mechanical Production Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MPI.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "industrial Engineering and Management",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, industrial Engineering and Management Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Energy Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Energy Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Energetika.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Process Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Process Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProcesnoInzinjerstvo.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Heating, Ventilation, and Air Conditioning",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Heating, Ventilation, and Air Conditioning Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/KGH.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wood Technology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Wood Technology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/TehnologijeDrveta.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "IC Engines and Vehicles",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, IC Engines and Vehicles Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MotoriIVozila.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Defense Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Defense Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Mechanical Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Mechanical Engineering, Mechanical Design Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "22.09.2005.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Ma%C5%A1inskeKonstrukcije.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Production Technologies, Automation and Robotics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Production Technologies, Automation and Robotics Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProizvodneTehnologijeAutomatizacijaRobotika.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "industrial Engineering and Management",
    NacinRealizacijeNastave: "Full- Time/Distance Learning",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, industrial Engineering and Management Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Energy Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Energy Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Energetika_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Process Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Process Engineering Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProcesnoInzinjerstvo_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Heating, Ventilation, and Air Conditioning",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Heating, Ventilation, and Air Conditioning Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/KGH_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Mechanical Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Mechanical Design Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MasinskeKonstrukcije_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "IC Engines and Vehicles",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, IC Engines and Vehicles Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MIV_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Defense Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Defense Technologies Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wood Technology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Mechanical Engineering, Wood Technology Track",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.05.2008.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/TehnologijeDrveta_II.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Renewable Energy Sources and Environmental Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.11.2011.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Obnovljivi%20izvori%20energije%20i%20okolinske%20tehnologije_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Mechanical Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "2014/15",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Ma%C5%A1inskeKonstrukcije_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Development of Modern IC Engines and Vehicles",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "2014/15",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/RazvojSavremenihMotoraIVozila_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Defense Technologies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "2014/15",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "",
    NazivStudijskogPrograma: "Mechanics",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "2014/15",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Mehanika_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Mechanical Production Engineering",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2017.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MPI_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Technical Sciences",
    FakultetAkademija: "Faculty of Mechanical Engineering",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "industrial Engineering and Management",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Mechanical Engineering",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "24.05.2017.",
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM_III.aspx" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Teaching Fine Arts",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts \u2013 Teaching Fine Arts",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013.",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/nastavnicki/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Painting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts-Painting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/slikarstvo/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Sculpture",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts-Sculpture",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/kiparstvo/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Printmaking",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts-Printmaking",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/grafika/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Graphic Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts -Graphic Design",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/graficki-dizajn/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Product Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Fine Arts \u2013Product Design",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/produkt-dizajn/ciklus-i" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts and Faculty of Science",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "interdisciplinary Program \u2013 Conservation and Restoration",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Conservation and Restoration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.05.2013",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/interdisciplinarni-studijski-program-konzervacija-i-restauracija-i-ciklus" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Teaching",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts - Teaching Fine Arts",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/nastavnicki/ciklus-ii-nastavnicki" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Painting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts - Painting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/slikarstvo/ciklus-ii" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sculpture",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts \u2013 Sculpture",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/kiparstvo/ciklus-ii" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Printmaking",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts \u2013 Printmaking",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/grafika/ciklus-ii" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Graphic Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts \u2013 Graphic Design",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/graficki-dizajn/ciklus-ii" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Product Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts \u2013Product Design",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012.God.",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/produkt-dizajn/ciklus-ii" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Photography",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Fine Arts - Photography",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "27.06.2012",
    LinkNaStudijskiProgram: <a href="/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Fine Arts, Faculty of Science and Faculty of Architecture",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "interdisciplinary Programme Conservation and Restoration",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Conservation and Restoration",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "26.04.2017",
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/content/interdisciplinarni-studijski-program-konzervacija-i-restauracija-ii-ciklus" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Acting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Performing Arts- Acting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-acting" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Directing",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Performing Arts- Directing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Directing- Audio Visual Media Arts Orientation: Camera, Editing, Recording and Sound Design",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Audiovisual Media Arts-Camera Operator Bachelor of Audiovisual Arts- Editor Bachelor of Audiovisual Arts- Sound Designer",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing/av-usmjerenja" target="_blank"> LINK  </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Dramaturgy",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Performing Arts- Dramaturgy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-dramaturgy" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Production and Management of Performing Arts",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Performing Arts- Production and Management",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-production" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Acting MA",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Perfoming Arts- Acting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-acting" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Directing MA",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Perfoming Arts- Directing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "16.07.2014.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Dramaturgy MA",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Perfoming Arts- Dramaturgy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "25.05.2016.",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-dramaturgy" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Performing Arts",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Production and Management of Performing Arts MA",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Perfoming Arts- Production",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "26.06.2013",
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-production" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Composition",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Composition",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Conducting/ Orchestral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Orchestral Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Conducting/ Choral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts - Choral Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Solo Singing",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Solo Singing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Piano",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts - Piano",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Department of Piano, Percussions, Harp and Related instruments/Percussions",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Percussions",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Harp",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts - Harp",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Violin",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Violin",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Viola",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Viola",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Violoncello",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Violoncello",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Contrabass",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Contrabass",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Guitar",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Guitar",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Flute",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Flute",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wwind instruments and Accordion/ Oboe",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Oboe",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Clarinet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Clarinet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Saxophone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Saxophone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Bassoon",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Bassoon",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trumpet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Trumpet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trombone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Trombone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ French Horn",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 French Horn",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Accordion",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Arts \u2013 Accordion",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Musicology and Ethnomusicology/ Musicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Musicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Musicology and Ethnomusicology/ Ethnomusicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Ethnomusicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "I",
    NazivStudijskogPrograma: "Music Theory and Pedagogy",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Bachelor of Music Theory and Pedagogy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "240",
    DatumSaglasnostiZaIzvodjenjeStudija: "29.06.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Composition",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Composition",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Conducting/ Orchestral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Orchestral Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Conducting/ Choral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Choral Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Solo Singing / Concert Singing",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Solo Singing - Concert Singing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Solo Singing / Opera Singing",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013Solo Singing - Opera Singing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Piano",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Piano",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Department of Piano, Percussions, Harp and Related instruments/ Accompaniment",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Accompaniment",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/ Piano Teaching Methods",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Piano Teaching Methods",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Percussions",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Percussions",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Percussions, Harp and Related instruments/Harp",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Harp",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Sstringed instruments and Guitar/Violin",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Violin",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Viola",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Viola",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Violoncello",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Violoncello",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/Contrabass",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Contrabass",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Department of Stringed instruments and Guitar/Guitar",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Guitar",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Flute",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Flute",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Oboe",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Oboe",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Clarinet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Clarinet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Saxophone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Saxophone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Bassoon",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Bassoon",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trumpet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Trumpet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trombone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Trombone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ French Horn",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 French Horn",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Accordion",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Arts \u2013 Accordion",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Musicology and Ethnomusicology/ Musicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Musicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Musicology and Ethnomusicology/ Ethnomusicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Ethnomusicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Music Theory and Pedagogy / Solfeggio",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Theory and Pedagogy - Solfeggio",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Music Theory and Pedagogy / Harmony",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Theory and Pedagogy - Harmony",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Music Theory and Pedagogy / Counterpoint",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Theory and Pedagogy - Counterpoint",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Music Theory and Pedagogy / Musical Forms and Styles",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Theory and Pedagogy \u2013 Musical Forms and Styles",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Music Theory and Pedagogy / Music Teaching Methods",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Music Theory and Pedagogy \u2013 Music Teaching Methods",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2011",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Composition",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Composing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Conducting / Orchestral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Conducting / Choral Conducting",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Conducting",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Solo Singing",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Solo Singing",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Piano",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Piano",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Department of Piano, Percussions, Harp and Related instruments/Percussions",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Percussions",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Piano, Percussions, Harp and Related instruments/Harp",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Harp",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/ Violin",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Stringed instruments - Violin",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/ Viola",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Stringed instruments - Viola",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/ Violoncello",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Stringed instruments - Violoncello",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/ Contrabass",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Art in The Area of Stringed instruments - Contrabass",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Stringed instruments and Guitar/ Guitar",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts - Guitar",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Flute",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Flute",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Oboe",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Oboe",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Clarinet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Clarinet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Saxophone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Saxophone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Bassoon",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Bassoon",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trumpet",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Trumpet",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Trombone",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments - Trombone",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ French Horn",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts in The Area of Wind instruments \u2013 French Horn",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Wind instruments and Accordion/ Accordion",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Arts - Accordion",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Musicology and Ethnomusicology / Musicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Science in The Area of Musicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Department of Musicology and Ethnomusicology / Ethnomusicology",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Science in The Area of Ethnomusicology",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "Arts",
    FakultetAkademija: "Academy of Music",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Department of Music Theory and Pedagogy",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Doctor of Music Science in The Area of Music Theory and Pedagogy",
    JezikStudija: "Bosnian, Croatian and Serbian",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "02.06.2010",
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "European Regional Master\u2019s Programme in Democracy and Human Rights in South East Europe",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Democracy and Human Rights",
    JezikStudija: "English",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "08.07.2009. Decision Nr. 01-38-1710/09; 26.04.2017 Decision Nr. 01-3098/17",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/erma-2/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Program in European Studies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of European Studies",
    JezikStudija: "Bosnian,Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120 60",
    DatumSaglasnostiZaIzvodjenjeStudija: "14.07.2010. Decision Nr. 01-38-1962/10; 26.04.2017 Decision Nr. 01-3099/17",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/evropske-studije/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Program Management of State and Non-Governmental Organizations",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Management of State and Non-Governmental Organizations",
    JezikStudija: "Bosnian,Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "/120",
    DatumSaglasnostiZaIzvodjenjeStudija: "23.12.2009. Decision Nr. 01-38-3206-3/09; 24.06.2015 Decision Nr. 01-4051/15",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/upravljanje-drzavom-i-nevladinim-organizacijama/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Program in Gender Studies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Gender Studies",
    JezikStudija: "Bosnian,Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "28. 04.2010. Decision Nr. 01-38-1224/10",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/rodne-studije/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Program One Health",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of One Health",
    JezikStudija: "Bosnian,Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "60",
    DatumSaglasnostiZaIzvodjenjeStudija: "28.10.2015. Decision Nr. 0101-85-1/16",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/jedinstveno-zdravlje/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "II",
    NazivStudijskogPrograma: "Master Program in Nutrition",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Nutrition",
    JezikStudija: "Bosnian,Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "120",
    DatumSaglasnostiZaIzvodjenjeStudija: "26.04.2017 Decision Nr.01-3096/17",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/nutrition/" target="_blank"> LINK </a>
  },
  {
    GrupacijaNaukaUmjetnosti: "UNSA",
    FakultetAkademija: "Center For interdisciplinary Studies",
    CiklusStudija: "III",
    NazivStudijskogPrograma: "Doctoral Program in Gender Studies",
    NacinRealizacijeNastave: "Full-Time",
    NazivKvalifikacijeIOdgovarajucaTitula: "PhD in Social Sciences in The Field of Gender Studies",
    JezikStudija: "Bosnian, Croatian, Serbian and English",
    TrajanjeCiklusaStudijaECTS: "180",
    DatumSaglasnostiZaIzvodjenjeStudija: "26. 06. 2013. Decision Nr. 01-38-2087/13",
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/doktorski/doktorski-studij-rodne-studije/" target="_blank"> LINK </a>
  }, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Center For interdisciplinary Studies',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master Program International and Regional Security',
    NacinRealizacijeNastave: 'Full-time',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master of International and Regional Security',
    JezikStudija: 'English ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/medunarodna-i-regionalna-sigurnost/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Center For interdisciplinary Studies',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master Program Natural Disasters Risk Management in Western Balkan Countries',
    NacinRealizacijeNastave: 'Full-time',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master of Natural Disasters Risk Management',
    JezikStudija: 'Bosnian, Croatian, Serbian and English ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/zastita-od-prirodnih-katastrofa/" target="_blank"> LINK </a>
}
];

export const studijskiProgrami = [{
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek Ekonomija',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/ Bachelor ekonomije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-3637/08 od 29.10.2008./ 01-5853/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek Menadžment',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor menadžmenta',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-3637/08 od 29.10.2008./ 01-5853/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek Visoka poslovna škola',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor poslovanja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-3637/08 od 29.10.2008./ 01-5853/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studij u saradnji sa Griffith College Dablin, Irska',
    NacinRealizacijeNastave: 'Redovan  ',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor menadžmenta',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-482/09 od 25.02.2009./ 01-38-2327/10 od 22.09.2010.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/bachelor_in_business_studies_2015_web.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek Ekonomija',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ekonomije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-3637/08 od 29.10.2008.  01-I-1501/08 od 14.05.2008./ 01-38-1228/10 od 28.04.2010.  1-5853/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek Menadžment',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar menadžmenta',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-3637/08 od 29.10.2008.  01-I-1501/08 od 14.05.2008./ 01-38-1228/10 od 28.04.2010.  1-5853/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ects_2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Zajednički master programi u saradnji sa Ekonomskim fakultetom Sveučilišta u Zagrebu',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ekonomije/menadžmenta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60  120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1501/08 od 14.05.2008./ 01-38-3730/10 od 01.12.2010.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/bs/programi-ii-ciklusa" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Zajednički master program u saradnju sa Ekonomskim fakultetom Univerzitet u Ljubljani  menadžmenta “Javni sektor i ekonomija okoliša”',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ekonomije/',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1397/08 od 16.07.2008./ 01-5855/15 od 30.09.2015.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/ljubljana_-_brosura_0.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Zajednčki master program sa Univerzitetom Bolton  Islamsko bankarstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar menadžmenta',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-2083/13 od 26.06.2013./ 01- 3679/16 od 25.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/islamsko_bankarstvo_-_npp.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master program u saradnji sa Microsoftom',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar menadžmenta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60  120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-1457/17 od 22.02.2017',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/sites/default/files/efsamicrosoftbih-mis.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Ekonomija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor ekonomskih nauka',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1502/08 od 14.05.2008./ 01-5854/15 od 30.09.2015',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/docs/Doktorski%20studij/Doktorski-Course-Catalogue_2012.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Ekonomski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Menadžment/Business',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor ekonomskih nauka',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1502/08 od 14.05.2008./ 01-5854/15 od 30.09.2015',
    LinkNaStudijskiProgram: <a href="http://www.efsa.unsa.ba/ef/docs/Doktorski%20studij/Doktorski-Course-Catalogue_2012.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Međunarodni odnosi i diplomatija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor politologije-usmjerenje Međunarodni odnosi i diplomatija',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-624/13 od 06.03.2013.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EZlEKhqsM4lPoluBFGOGSnMBUsZKoexwBgizUZpY6dJyvw?e=95rTbm" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Upravljanje državom',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor politologije - usmjerenje Upravljanje državom',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EelAoqyzh9NOn5ilyWQuPY4B8Edx0t-MkVg5Z81SdoWd7w?e=1yNIqV" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESmzNkM2Em1MsK4cugQv8sgBdzyqCbZp7zGQSfhoqtu2DA?e=krVKNq" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Žurnalistika/Komunikologija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor novinarstva/ komunikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESQlTioA1zlMvTf6C3e5Qa8Bcq7SWWtr1agKUYFk3aRBmw?e=1FVgrG" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sigurnosne i mirovne studije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor sigurnosnih i mirovnih studija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW0pvUZTk8NApYvUbxpkDsoBoebM-PagiKEPtEAbsHLkYg?e=tmhXEW" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Socijalni rad',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor socijalnog rada',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ESHihufoP6tJjr4UxD30mbsBNBcZw3_FggCacFIHRGP_uQ?e=IUNSl7" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Međunarodni odnosi i diplomatija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar politologije- usmjerenje Međunarodni odnosi i diplomatija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/Edcfa0-6NkhLu32v_L-uz9UBZfZr6xgYufYPVTKflLDWPA?e=Owe6Tg" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Međunarodni odnosi i diplomatija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar politologije- usmjerenje Međunarodni odnosi i diplomatija',
    JezikStudija: 'Bosanski, hrvatski, srpski   i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-624/13 od 06.03.2013.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EWvbAi-8xHtIpSQ36CIeRq0BjbdxsrKT9LKdM8F08_lQfg?e=8dt1uc" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Upravljanje državom',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar politologije- usmjerenje Upravljanje državom',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETQePsNFQq9LlM4_pI1TGHEB6KgNnOywsLYmzNba35Iedg?e=Epd2UP" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sociologija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EWdgN4ONVJBFpLzqiB9Ns70BYIZx9mgMLH_9PG6NnU-hFw?e=wdu1zE" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Žurnalistika/ Komunikologija',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar komunikologije/ novinarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EV52zXMmLYVHuI6ARAAbyRIBASHq_qA4r_eG2OTZ0pc5Bw?e=H8lqId" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sigurnosne i mirovne studije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sigurnosnih i mirovnih studija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETzlvbV8ouNIhsHRu55lKSYBg1zAA-TuAIBI-Kkpa9HWRg?e=btLULf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Socijalni rad',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar socijalnog rada',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2705/15 od 29.04.2015.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EZ6flL3PWTFElwa3irm_GfIBuiDZXB3eciPKnqgw2mifDw?e=yyTIlW" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Istraživačko polje sociologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor socioloških nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4464/16 od 29.06.2016.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EcLFGKUaNg5Gl-XAmQIsf9QBFb4gH-N9HSEyAkZ8clfFfQ?e=0m8vD2" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Istraživačko polje politologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor političkih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4464/16 od 29.06.2016.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EcV4FNW8AQNOg-wirbbXo2EBsxGbRR73U_IOK_Y97mPBKw?e=fbbHvc" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Istraživačko polje komunikologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor komunikoloških nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4464/16 od 29.06.2016.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW7bt8Wp-TBOgoOnB8tq1_QBwVgETaQpnoDGgRn-AiR3gQ?e=fA8dwp" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Istraživačko polje socijalni rad',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor nauka socijalnog rada',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4464/16 od 29.06.2016.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/ETV296wLBwhPsKDL2RiKyrUBf1QeHcar4LWgdhtFljtkag?e=Kc3LDw" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet političkih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Istraživačko polje sigurnosnih i mirovnih studija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor političkih nauka iz oblasti sigurnosnih i mirovnih studija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4464/16 od 29.06.2016.',
    LinkNaStudijskiProgram: <a href="https://fpnsarajevo-my.sharepoint.com/:b:/g/personal/web_administrator_fpn_unsa_ba/EW-e-xWmjYlLm-8qXPwXHh0B0UoJfLIz_JcbfkNqHLRPEQ?e=buyIKV" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet sporta i tjelesnog odgoja',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Opšti studij',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor sporta i tjelesnog odgoja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-991/06',
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-28-42/opci-smjer-240-ects" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet sporta i tjelesnog odgoja',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Menadžment u sportu  kondiciona priprema sportaša',
    NacinRealizacijeNastave: 'Vanredan, DL  Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor menadžmenta  Bachelor kondicione pripreme',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3671/17',
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-28-42/menadzment-u-sportu-180-ects" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet sporta i tjelesnog odgoja',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Opći studij',
    NacinRealizacijeNastave: 'Redovan/Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sporta i tjelesnog odgoja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1540/09',
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-35-57/opci-smjer-60-ects" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet sporta i tjelesnog odgoja',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Menadžment u sportu',
    NacinRealizacijeNastave: 'DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar menadžmenta u sportu',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1540/09',
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-35-57/menadzment-u-sportu-120-ects" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet sporta i tjelesnog odgoja',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz oblasti „Kineziologija“',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor društvenih nauka polje Kineziologija sa oznakom grane:  -kineziološka edukacija  -kineziološka rekreacija  -kineziologija sporta  -kineziološka kineziterapija  -organizacija i upravljanje u kineziologiji',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3159/13  01-8176/17',
    LinkNaStudijskiProgram: <a href="http://www.fasto.unsa.ba/index.php/2014-10-21-13-06-33/2014-10-21-13-43-49/doktorski-studij-iz-oblasti-kineziologije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Kriminalistika',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor kriminalistike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013./ 22.02.2017.',
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Kriminologija',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor kriminologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013./ 22.02.2017.',
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sigurnosne studije',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor menadžmenta sigurnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013./ 22.02.2017.',
    LinkNaStudijskiProgram: <a href="https://docs.wixstatic.com/ugd/7e0f63_b8f4e8b1b1464650ae12fe4b0aa68e4d.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Kriminalistika',
    NacinRealizacijeNastave: 'Redovan, Vanredan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar kriminalistike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013./ 30.09.2015.',
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/kriminalistika" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Kriminologija',
    NacinRealizacijeNastave: 'Redovan, Vanredan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar kriminologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013. /30.09.2015.',
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/kriminologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sigurnosne studije',
    NacinRealizacijeNastave: 'Redovan, Vanredan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sigurnosnih studije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013./ 30.09.2015.',
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/sigurnosne-studije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Krizni menadžment u sigurnosnom sektoru',
    NacinRealizacijeNastave: 'DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar kriznog menadžmenta u sigurnosnom sektoru',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/krizni-menadzment" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Korporativna sigurnost i zaštita',
    NacinRealizacijeNastave: 'DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar korporativne sigurnosti i zaštite',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '26.04.2017./ 25.10.2017.',
    LinkNaStudijskiProgram: <a href="https://www.masterprogrami.edu.ba/korporativna-sigurnost" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Kriminalistika',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor kriminalističkih nauka/znanosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '06.03.2013./ 23.12.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Kriminologija',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor kriminoloških nauka/znanosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '06.03.2013./ 23.12.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Sigurnosne studije',
    NacinRealizacijeNastave: 'Redovan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor sigurnosnih nauka/znanosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '06.03.2013./ 23.12.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fkn.unsa.ba/nastavni-proces" target="_blank"> LINK </a>
},{
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za kriminalistiku, kriminologiju i sigurnosne studije',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Upravljanje u kriznim situacijama',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: '',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '300',
    DatumSaglasnostiZaIzvodjenjeStudija: '2018.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Uprava',
    NacinRealizacijeNastave: 'Redovan , Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat /Bachelor uprave-smjer uprava',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.09.2017.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/prvi-ciklus/smjer-uprava/predmeti/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu Ekonomski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Informatika u upravi',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: '',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2015.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Uprava',
    NacinRealizacijeNastave: 'Redovan , Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar uprave',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.10.2017.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/drugi-ciklus/smjer-uprava-32-dvogodisnji-studij/predmeti/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Uprava',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar uprave',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '15.07.2015.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/drugi-ciklus/smjer-uprava/predmeti/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Poslovna uprava',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar uprave-smjer poslovna uprava',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/drugi-ciklus/smjer-poslovna-uprava/predmeti/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Javne nabavke u upravi',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar uprave-smjer javne nabavke u upravi',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/drugi-ciklus/magistar-uprave-smjer-javne-nabavke-u-upravi/predmeti/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Upravljanje projektima Evropske unije',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar uprave - smjer upravljanje projektima Evropske unije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '2019.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/drugi-ciklus/upravljanje-projektima-evropske/predmeti/" target="_blank"> LINK </a>
},{
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Fakultet za upravu',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Uprava',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor upravnih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '06.11.2013.',
    LinkNaStudijskiProgram: <a href="https://fu.unsa.ba/predmeti/ciklusi/treci-ciklus-doktorski-studij/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Pravni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Opći smjer na Pravnom fakultetu',
    NacinRealizacijeNastave: 'Redovan, Vanredan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat prava',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: "01-38-1335-7/'11 od 25.05.2011.  01-2704/15 od 29.04.2015.  01-555/16 od 27.01.2016.  01-3680/16 od 25.05.2016.  01-4765/16 od 13.07.2016.",
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/Nastavni-plan-i-program-1.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Pravni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'II studija na Pravnom fakultetu',
    NacinRealizacijeNastave: 'Redovan, Vanredan, DL',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master prava',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1225/10 od 28.04.2010.  01-2704/15 od 29.04.2015.  01-555/16 od 27.01.2016.  01-3680/16 od 25.05.2016.  01-4765/16 od 13.07.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/Nastavni-plan-i-program-II-ciklusa-studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Društvene nauke',
    FakultetAkademija: 'Pravni fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij na Pravnom fakultetu',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor pravnih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1716/11 od 29.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.pfsa.unsa.ba/pf/wp-content/uploads/2014/09/NOVI-DOKTORSKI.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Islamska teologija',
    NacinRealizacijeNastave: 'Redovan, RRedovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor islamske teologije',
    JezikStudija: 'bosanski',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3678/16 od 25.05.2016.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-I_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Islamska vjeronuaka i religijska pedagogija',
    NacinRealizacijeNastave: 'Redovan,  Redovan samofinansirajući,  Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor islamske vjeronauke i religijske pedagogije',
    JezikStudija: 'bosanski',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3678/16 od 25.05.2016.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-I_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program za imame, hatibe i muallime',
    NacinRealizacijeNastave: 'Redovan, Redovansamofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: "Bakalaureat/Bachelor imameta, hatabeta i ta'lima",
    JezikStudija: 'bosanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-4661/15 od 15.07.2015.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/silabusi/dodiplomski/studij-za-imame-npp.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master u islamskim naukama',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar islamskih nauka s naznakom uže znanstvene oblasti (Prijedlog: Magistar islamskih studija s naznakom uže znanstvene oblasti)',
    JezikStudija: 'bosanski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3678/16 od 25.05.2016.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2016/FIN-II_ciklus-revizija_NPP-2016.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Međureligijski studiji i izgradnja mira',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: "Magistar međureligijskih studija i izgradnje mira (zajednički master program Fakultet islamskih nauka Univerziteta u sarajevu, Katolički bogoslovni fakultet Univerziteta u Sarajevu i Pravoslavni bogoslovski fakultet ''Sv. Vasilije Ostroški'' u Foči Univerziteta u Istočnom Sarajevu",
    JezikStudija: 'Bosanski, hrvatski, srpski   i engleski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3678/17 od 24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2018/Elaborat.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master islamskh studija na engleskom jeziku',
    NacinRealizacijeNastave: 'Redovan-samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: "Master of Islamic Studies",
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/index.php/izdvojeno/4713-master-in-islamic-studies" target="_blank"> LINK </a>
},{
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master za imame',
    NacinRealizacijeNastave: 'Redovan-samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: "Magistar imameta",
    JezikStudija: 'Bosanski, hrvatski, srpski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/2018/elaborat-master-imami.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Fakultet islamskih nauka',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz islamskih nauka',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktorski studij iz islamskih nauka s naznakom uže znanstvene oblasti',
    JezikStudija: 'bosanski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-7902/15 od 23.12.2015.',
    LinkNaStudijskiProgram: <a href="http://fin.unsa.ba/datoteke/doktorski/doktorske-studije-elaborat.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.   02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i njemačkog  jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, engleski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Engleski jezik i književnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor engleskog jezika i književnosti i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor  bosanskoga, hrvatskoga i srpskoga jezika i bibliotekarstva',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i pedagogije',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i njemačkog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bosanskoga, hrvatskoga i srpskoga jezika i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija i sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije i sociologije',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija i njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije i njemačkog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>

}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije i komparativne književnosti',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Filozofija i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor filozofije i historije umjetnosti',
    JezikStudija: 'bosanski, hrvatski i srpski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauka',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, njemački i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, njemački  i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, njemački i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, njemački i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, njemački i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Njemački jezik i književnost i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor njemačkog jezika i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija  i arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije i arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.  01-I-1506/08. od 14.5.2008.  01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija i sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije i sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije i historije umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;  01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a>{'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauka',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i filozofije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i historije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Historija umjetnosti i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor historije umjetnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;  01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  .02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arheologija i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arheologije i historije umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '}<a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arheologija i historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arheologije i historije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '}<a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
}, {
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arheologija i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arheologije i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '}<a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arheologija i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arheologije i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '}<a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine i bosanski, hrvatski i srpski jezik  nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor književnosti naroda Bosne i Hercegovine i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor književnosti naroda Bosne i Hercegovine i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor književnosti naroda Bosne i Hercegovine i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i historije umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Komparativna književnost i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor komparativne književnosti i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bibliotekarstvo i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bibliotekarstva i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bibliotekarstvo i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bibliotekarstva i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bibliotekarstvo i njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bibliotekarstva i njemačkog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Bibliotekarstvo i historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor bibliotekarstva i historije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor perzijskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i perzijski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, arapski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i perzijski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i perzijskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, arapski i perzijski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, arapski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, arapski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor arapskog jezika i književnosti i filozofije',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i perzijski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i perzijskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti iarheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i historije',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Turski jezik i književnost i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor turskog jezika i književnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor perzijskog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, perzijski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor perzijskog jezika i književnosti i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, perzijski i arapski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor perzijskog jezika i književnosti i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski i perzijski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor perzijskog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, perzijski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Specijalne pedagogije',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor specijalne pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-7195/15 od 26. 11. 2015. .  02-01/405 od 11.11.2015.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;  01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>{'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i filozofije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;  01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>{'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Pedagogija i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor pedagogije i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Psihologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor psihologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-46-21" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost  i filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i filozofije',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i kjiževnost  i ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i  književnosti i ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i kjiževnost  i njemački jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i  književnosti i njemačkog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor francuskog jezika i književnosti i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, italijanski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, italijanski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i historije  umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i latinski jezik i rimska književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i latinskog jezika i rimske književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, italijanski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i  književnosti i arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor italijanskog jezika i književnosti i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski  i italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, latinski i  engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, latinski i  italijanski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i historije',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, latinski i turski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i bosanski, hrvatski i srpski jezik',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i bosanskoga, hrvatskoga i srpskoga jezika',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i historije  umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor latinskog jezika i rimske književnosti i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, latinski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Ruski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor ruskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Ruski jezik i književnost i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor ruskog jezika i književnosti i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski i ruski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Ruski jezik i književnost i engleski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor ruskog jezika i književnosti i engleskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, ruski i engleski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologije i etnologije',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i etnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-7199/15 od 26. 11. 2015.   02-01/422 od 1.12.2015.  02-01/418 od 11.11.2015.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija i historija umjetnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i historije umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sociologija i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor sociologije i književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Engleski jezik i književnost - nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar engleskog jezika i književnosti - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Engleski jezik i književnost - prevodilački smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar engleskog jezika i književnosti - književni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Engleski jezik i književnost - lingvistički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar engleskog jezika i književnosti - lingvistički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Engleski jezik i književnost - književni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar engleskog jezika i književnosti - prevodilački smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-13-22-32-48" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik  lektorski smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bosanskoga, hrvatskoga i srpskoga jezika  lektorski smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i književnosti naroda Bosne i Hercegovine  nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bosanskoga, hrvatskoga i srpskoga jezika i književnosti naroda Bosne i Hercegovine  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i italijanski jezik i književnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bosanskoga, hrvatskoga i srpskoga jezika i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bosanski, hrvatski i srpski jezik i jezik i francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bosanskoga, hrvatskoga i srpskoga jezika i francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Filozofija - nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar filozofije  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Filozofija  znanstveni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar filozofije  znanstveni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-24-43" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Njemački jezik i književnost  nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar njemačkog jezika i književnosti  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Njemački jezik i književnost  književni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar njemačkog jezika i književnosti - književni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-14-00-32-30" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija - nastavni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija - naučni smjer (oblast stari vijek)',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije  naučni smjer (oblast stari vijek)',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija - naučni smjer (oblast novi vijek)',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije  (oblast novi vijek)',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije  nastavnički smjer i pedagogije  strukovni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti  nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1975-14/12 od 18. 7. 2012.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Moderna i savremena umjetnost i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Moderna i savremena umjetnost  naučni smjer i pedagogije  strukovni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine i arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer i arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine i historija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer i historije  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-27-35" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Moderna i savremena umjetnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Moderna i savremena umjetnost  naučni smjer i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Historija umjetnosti - Moderna i savremena umjetnost i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar historije umjetnosti: Moderna i savremena umjetnost  naučni smjer i komparativne književnost',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arheologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arheologija i historija umjetnosti (Moderna i savremena umjetnost)',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arheologije i historije umjetnosti: Moderna i savremena umjetnost  naučni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arheologija i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arheologije i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-293/08 od 30.1.2008.;  01-I-1506/08. od 14.5.2008.;   01-I-1508/08 od 14.5.2008.  01-I-1509/08 od 14. 5. 2008.  02-01/163 od 21.6.2008.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-30-25" target="_blank"> LINK </a>{'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine  naučni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar književnosti naroda Bosne i Hercegovine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine i bosanski, hrvatski i srpski jezik  nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar književnosti naroda Bosne i Hercegovine i bosanskoga, hrvatskoga i srpskoga jezika  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/nastavni-planovi-i-programi" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Književnosti naroda Bosne i Hercegovine i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar književnosti naroda Bosne i Hercegovine i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Komparativna književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar komparativne književnosti i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bibliotekarstvo i pedagogija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bibliotekarstva i pedagogije  strukovni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bibliotekarstvo i historija umjetnosti  Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bibliotekarstva i historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Bibliotekarstvo i književnosti naroda Bosne i Hercegovine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar bibliotekarstva i',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-36-41" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Komparativna književnost i historija umjetnosti - moderna i savremena umjetnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar komparativne književnosti i historije umjetnosti: Moderna i savremena umjetnost  naučni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Komparativna književnost i historija umjetnosti - Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar komparativne književnosti i historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arapski jezik i književnost  opći smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i arapski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Turski jezik i književnost  opći smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i turski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Perzijski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar perzijskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i perzijski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Turski jezik i književnost i arapski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar turskog jezika i književnosti i arapskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i arapski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Turski jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar turskog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, turski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arapski jezik i književnost i turski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arapskog jezika i književnosti i turskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, arapski i turski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-42-27" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Pedagogija  strukovni studij',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar pedagogije - strukovni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Pedagogija i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar pedagogije  strukovni smjer i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-44-33" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Psihologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar psihologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-46-21u" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Francuski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar francuskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i francuski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Italijanski jezik i književnost i historija umjetnosti (Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine)',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar italijanskog jezika i književnosti i historije umjetnosti: Umjetnost na tlu Bosne i Hercegovine od 15. stoljeća do 1918. godine  naučni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-32-43" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar francuskog jezika i književnosti i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Francuski jezik i književnost i latinski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar francuskog jezika i književnosti i latinskog jezika s rimskom  književnošću',
    JezikStudija: 'Bosanski, hrvatski, srpski, francuski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i italijanski jezik i književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar latinskog jezika s rimskom književnošću i italijanskog jezika i književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski, latinski i italijanski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i komparativna književnost',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar latinskog jezika s rimskom književnošću i komparativne književnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-3" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Latinski jezik i rimska književnost i bibliotekarstvo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar latinskog jezika s rimskom književnošću i bibliotekarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski i latinski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <div><a href="http://ff.unsa.ba/index.php/bs/2014-12-18-00-10-31" target="_blank"> LINK  </a> {'  |  '} <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-22-39-55" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Ruski jezik i književnost  nastavni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ruskog jezika i književnosti - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski i ruski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-15-23-03-35" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sociologija - nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sociologije  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sociologija - znanstveni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sociologije  znanstveni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sociologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar sociologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '02-01/156 od 15.7.2005.  02-01/177 od 27.9.2005.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/index.php/bs/2014-12-11-07-21-00" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij IZ  matične oblasti sociologija, Savremena sociologija i globalizacijski procesi',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor socioloških nauka/znanosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-2315/10 od 22.9.2010.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz matične oblasti filozofija, studijska linija 2. Suvremena filozofija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor filozofskih znanosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3684/11 od 28.12.2011.  01-4518/17 od   27. 6.2017.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz književnosti naroda bih',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor/ica književnohistorijskih nauka  književnosti naroda BiH',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1975/12 od 18.7.2012.  01-4514/17 od 27.6.2012.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz psihologije',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor psiholoških nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3684-1/11 od 28.12.2011.  0101-38-2380/13 od 17.7.2013.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz historije (smjerovi: Prostor Bosne i Hercegovine u kontekstu antičke Europe i Mediterana, Historija srednjovjekovne Bosne, Historija Bosne i Hercegovine u osmanskom periodu (1463-1839), Historija Bosne i Hercegovine u 19. i 20. stoljeću)',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor historijskih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-767/11 od 30.3.2011.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij njemački jezik i njemačka književnost u kontekstu medijske kulture',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor književnohistorijskih oblasti (germanistika) ili  Doktor lingvističkih nauka (germanistika)  Doktor lingvističkih nauka (germanistika)',
    JezikStudija: 'Bosanski, hrvatski, srpski i njemački',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-769/11 od 30.3.2011.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz lingvistike',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor lingvističkih  nauka/znanosti, smjer: engleski jezik  Doktor lingvističkih  nauka/znanosti, smjer: bosanski, hrvatski i srpski jezik  Doktor lingvističkih  nauka/znanosti, smjer: bosanski, hrvatski i srpski jezik  Doktor lingvističkih  nauka/znanosti, smjer: Francuski  jezik   Doktor lingvističkih  nauka/znanosti, smjer: Francuski  jezik',
    JezikStudija: '',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-34-265/12 od 25.4.2012.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Treći ciklus studija- doktorski studij iz lingvistike',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor lingvističkih  nauka/znanosti, smjer: engleski jezik  Doktor lingvističkih  nauka/znanosti, smjer: bosanski, hrvatski i srpski jezik  Doktor lingvističkih  nauka/znanosti, smjer: bosanski, hrvatski i srpski jezik  Doktor lingvističkih  nauka/znanosti, smjer: Francuski  jezik   Doktor lingvističkih  nauka/znanosti, smjer: Francuski  jezik',
    JezikStudija: '',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-34-265/12 od 25.4.2012.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Treći ciklus studija- doktorski studij iz lingvističke bosnistike',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor lingvističkih nauka  bosnist   U dodatku diplome mora stajati i smjer specijalizacije (savremeni jezik ili historija jezika ili arealna lingvistika)  U dodatku diplome mora stajati i smjer specijalizacije (savremeni jezik ili historija jezika ili arealna lingvistika)',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1144-2/12 od 25.4.2012.  01-4466/16 od 29.6.2016.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Treći ciklus studija- doktorski studij književnosti',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor književnih nauka/znanosti (pripadajuće polje/grana)   Književnosti na engleskom jeziku (engleska, britanska, američka, postkolonijalna književnost)  Književnosti na engleskom jeziku (engleska, britanska, američka, postkolonijalna književnost)  Doktor književnih nauka/znanosti  (pripadajuće  polje/grana) Arapska književnost  (pripadajuće  polje/grana) Arapska književnost  Doktor književnih nauka/znanosti  (pripadajuće  polje/grana) Arapska književnost  (pripadajuće  polje/grana) Arapska književnost  (pripadajuće  polje/grana) Perzijska književnost  (pripadajuće  polje/grana) Rimska književnost (književnosti na latinskom jeziku)  (pripadajuće  polje/grana) Rimska književnost (književnosti na latinskom jeziku)  (pripadajuće  polje/grana) Perzijska književnost  (pripadajuće  polje/grana) Rimska književnost (književnosti na latinskom jeziku)  (pripadajuće  polje/grana) Rimska književnost (književnosti na latinskom jeziku)',
    JezikStudija: '',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-997/13 od 3.4.2013.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz književnosti pod naslovom književnost i kultura',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor književnih nauka/znanosti  komparativna književnost',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1673/13 od 24.4.2013.  01-4465/16 od 29.6.2016.  01-6081/17 od 27.9.2017.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij iz pedagogije - Teorije i istraživanja kreativnog odgoja i obrazovanja',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor iz područja društvenih/humanističkih nauka, polje Odgojne nauke i nauke pedagogije (Dr. sc. pegagogije + Diploma Supplement)',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '1-38-1828/14 od 7.5.2014.',
    LinkNaStudijskiProgram: ''
},  {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Filozofski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij arheologije',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor nauka arheologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2020.',
    LinkNaStudijskiProgram: <a href="http://ff.unsa.ba/files/doktorskiStudiji/19-20/NPP-Doktorski-studij-Arheologija-2019-2020.pdf" target="_blank"> LINK </a>
},{
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Katolički bogoslovni fakultet',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Filozofsko-teološki studij',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar (master) teologije',
    JezikStudija: 'hrvatski',
    TrajanjeCiklusaStudijaECTS: '300',
    DatumSaglasnostiZaIzvodjenjeStudija: '28. 9. 2016.',
    LinkNaStudijskiProgram: <a href="http://kbf.ba/page.php?id=338" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Katolički bogoslovni fakultet',
    CiklusStudija: 'II.',
    NazivStudijskogPrograma: 'Međureligijski studij i izgradnja mira',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master iz međureligijskih studija i izgradnje mira.',
    JezikStudija: 'Bosanski, hrvatski, srpski   i engleski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '24. 5. 2017.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za predškolski odgoj',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor  predškolskog odgoja  predškolskog odgoja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1705/09 od08.07.2009.  01-38-485-1/11 od 23.02.2011.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/programi%20PO%20PF%206-4-11.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za razrednu nastavu',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor  razredne nastave  razredne nastave',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1705/09 od 08.07.2009./   01-38-485-1/11 od 23.02.2011.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/programi%20RN%20%20PF%206-4-11.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za kulturu življenja i tehnički odgoj',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor kulture življenja i tehničkog odgoja sa informatikom',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3206-4/09 od 23.12.2009.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/KZTO%20sa%20informatikom.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za edukaciju i rehabilitaciju',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor edukacije i rehabilitacije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3766/16 od 25.05.2016. /  11-05-38-565-3/16 od 31.10.2016.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/NPP_edukacija_rehabilitacija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za predškolski odgoj',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar predškolskog odgoja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1705/09 od 08.07.2009.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/PO_5_godina.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za razrednu nastavu',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar razredne nastave',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1705/09 od 08.07.2009.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/RN_5_godina.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za kulturu življenja i tehnički odgoj',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar kulture življenja i tehničkog odgoja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1705/09 od 08.07.2009./   01-5052/17 od 19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/NPP/KZTO_diplomski_5_godina.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za edukaciju i rehabilitaciju',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar edukacije i rehabilitacije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3766/16 od 25.05.2016./  11-05-38-565-3/16 od 31.10.2016.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/NPP_edukacija_rehabilitacija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Humanističke nauke',
    FakultetAkademija: 'Pedagoški fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Savremeni tokovi predškolskog i osnovnoškolskog odgoja i obrazovanja',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor odgojnih nauka  Doktor odgojnih nauka- Metodika bosanskog, hrvatskog, srpskog jezika i književnosti u početnoj nastavi osnovne škole  Doktor odgojnih nauka- Metodika bosanskog, hrvatskog, srpskog jezika i književnosti u početnoj nastavi osnovne škole  Doktor odgojnih nauka - Metodika muzičke kulture u početnoj nastavi osnovne škole  Doktor odgojnih nauka - Metodika muzičke kulture u početnoj nastavi osnovne škole',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3134/12 od 27.12.2012./   01-38-621/13 od 06.03.2013./  01-5051/17 od 19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://pf.unsa.ba/images/dokumenti_PDF/20180115_NPP_III_ciklus.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Fizikalna terapija',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor fizikalne terapije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/fizikalna-terapija" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
        FakultetAkademija: 'Fakultet zdravstvenih studija',
        CiklusStudija: 'I',
        NazivStudijskogPrograma: 'Zdravstveni nutricionizam i dijetetika ',
        NacinRealizacijeNastave: 'Redovni, Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor Zdravstvenog nutricionizma i dijetetike',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '240',
        DatumSaglasnostiZaIzvodjenjeStudija: '2020..',
        LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/studijski-program-zdravstveni-nutricionizam-i-dietetika" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
        FakultetAkademija: 'Fakultet zdravstvenih studija',
        CiklusStudija: 'I',
        NazivStudijskogPrograma: 'Babičarstvo/Porodiljstvo/Primaljstvo',
        NacinRealizacijeNastave: 'Redovni, Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor babičarstva/porodiljstva',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '240',
        DatumSaglasnostiZaIzvodjenjeStudija: '2020.',
        LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/studijski-program-babicarstvo-primaljstvo" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Laboratorijske tehnologije',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor laboratorijskih tehnologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/laboratorijske-tehnologije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Radiološke tehnologije',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor radioloških tehnologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/radioloske-tehnologije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Sanitarno inžinjerstvo',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor sanitarnog inžinjerstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/sanitarno-inzinjerstvo" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Zdravstvena njega',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor zdravstvene njege',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  04.06.2014.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/1-ciklus/zdravstvena-njega" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fizikalna terapija',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master fizikalne terapije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  29.05.2013.  28.01.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/fizikalna-terapija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Laboratorijske tehnologije',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master  laboratorijskih tehnologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  29.05.2013.  28.01.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/laboratorijske-tehnologije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Radiološke tehnologije',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master radioloških tehnologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  29.05.2013.  28.01.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/radioloske-tehnologije" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Sanitarno inžinjerstvo',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master  sanitarnog inžinjerstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  29.05.2013.  28.01.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/sanitarno-inzinjerstvo" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Fakultet zdravstvenih studija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Zdravstvena njega',
    NacinRealizacijeNastave: 'Redovni, Vanredni',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Master zdravstvene njege',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.04.2009.  29.05.2013.  28.01.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fzs.unsa.ba/edukacija/ii-ciklus/zdravstvena-njega" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Farmaceutski fakultet',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Integrirani studij prvog i drugog ciklusa',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Stručno zvanje Magistar farmacije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '300',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3502/15 od 27.05.2015.',
    LinkNaStudijskiProgram: <a href="https://ffsa.unsa.ba/wp-content/uploads/2017/12/Nastavni-plan-i-program-ECTS-katalog-2015.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Farmaceutski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Farmaceutska istraživanja',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Naučni stepen Doktor farmaceutskih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2013',
    LinkNaStudijskiProgram: <a href="https://ffsa.unsa.ba/wp-content/uploads/2014/03/NASTAVNI-PLAN-I-PROGRAM-III-CIKLUSA-Farmaceutska-istra%C5%BEivanja-1.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Medicinski fakultet',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Medicina',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor medicine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '360',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2015.',
    LinkNaStudijskiProgram: <a href="http://www.mf.unsa.ba/index.php/studijski-programi-i-edukacija/dodiplomski-studij" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Medicinski fakultet',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Medicina',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor medicine',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '360',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.02.2015.',
    LinkNaStudijskiProgram: <a href="http://en.mf.unsa.ba/data/Nastavni_plan_i_program_na_engleskom_jeziku.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Medicinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Biomedicina i zdravstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor medicinskih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '26.06.2013.',
    LinkNaStudijskiProgram: <a href="http://mf.unsa.ba/podaci/dokumenti/doktorski/Reformisani_Curriculum_doktorskog_studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Stomatološki fakultet sa klinikama',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'I i II Integrisani studij',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor dentalne medicine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '360',
    DatumSaglasnostiZaIzvodjenjeStudija: '13.07.2017.',
    LinkNaStudijskiProgram: <a href="http://sf.unsa.ba/bs/bolonjski-studij/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Stomatološki fakultet sa klinikama',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor stomatoloških nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://sf.unsa.ba/bs/studij-i-programi/doktorski/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
    FakultetAkademija: 'Veterinarski fakultet',
    CiklusStudija: 'Integrirani',
    NazivStudijskogPrograma: 'Veterinarska medicina',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor veterinarske medicine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '300',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.09.2013.',
    LinkNaStudijskiProgram: <a href="http://vfs.unsa.ba/student/VFS_stud_vodic_BOS_2018_ver_17012018.pdf" target="_blank"> LINK </a>
},
    {
        GrupacijaNaukaUmjetnosti: 'Medicinske nauke',
        FakultetAkademija: 'Veterinarski fakultet',
        CiklusStudija: 'III',
        NazivStudijskogPrograma: 'Veterinarska medicina i javno zdravstvo',
        NacinRealizacijeNastave: 'Redovan',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor veterinarske medicine',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '180',
        DatumSaglasnostiZaIzvodjenjeStudija: '25.09.2013.',
        LinkNaStudijskiProgram: <a href="http://vfs.unsa.ba/web/index.php/nastava/doktorski-studij/opce-informacije" target="_blank"> LINK </a>
    },
    {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Ratarstvo i povrtlarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20RATARSTVO%20i%20POVRTLARSTVO_%20odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Voćarstvo i vinogradarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20VOCARSTVO%20i%20VINOGRADARSTVO_odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Animalna proizvodnja',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor zootehnike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20programi%20ANIMALNA%20PROIZVODNJA-AKVAKULTURA-%20odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Akvakultura',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor zootehnike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20programi%20ANIMALNA%20PROIZVODNJA-AKVAKULTURA-%20odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Prehrambene tehnologije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor Prehrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE_odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Ekonomika poljoprivrede i prehrambene industrije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor ekonomike poljoprivrede i prehrambene industrije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1687-1/05 od 26. 10. 2005',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20EKONOMIKA%20AGROINDUSTRIJE_odsjek%20Ekonomika%20poljoprivrede%20i%20prehrambene%20industrije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Održivo upravljanje zemljištem i ruralnim prostorom',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20ODRZIVO%20UPRAVLJANJE%20ZEMLJISTEM%20I%20RURALNIM%20PROSTOROM-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fitomedicina',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20FITOMEDICINA-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Ratarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20RATARSTVO-II%20ciklus-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Povtlarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20POVRTLARSTVO-II%20ciklus%20studija-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Voćarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20VOCARSTVO-II%20ciklus-odsjek%20Biljna%20PROIZVODNJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Floristika i pejzašno oblikovanje',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20FLORISTIKA%20I%20PEJZASNO%20OBLIKOVANJE-II%20ciklus%20studija-odsjek%20Biljna%20proizvodnja.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Vinogradarstvo i vinarstvo',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biljne proizvodnje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/studijskiprogramIICIKLUS.php" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Ekonomika agroindustrije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ekonomike poljoprivrede i prehrambene industrije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20EKONOMIKA%20AGROINDUSTRIJE-II%20ciklus-odsjek%20Ekonomika%20poljoprivrede%20i%20prehrambene%20industrije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Animalna proizvodnja',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar zootehnike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20ANIMALNA%20PROIZVODNJA-II%20ciklus%20studija-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Hrana i ishrana životinja',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar zootehnike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20HRANA%20I%20ISHRANAZIVOTINJA-II%20ciklus%20studija-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Akvakultura',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar zootehnike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20AKVAKULTURA-II%20ciklus-odsjek%20Zootehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Kontrola kvaliteta hrane i pića',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar prehrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20KONTROLA%20KVALITETA%20HRANE%20I%20PICA-II%20ciklus%20studija-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Tehnologija proizvoda animalnog porijekla',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar prehrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE%20ANIMALNOG%20PORIJEKLA-II%20ciklus-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Tehnologija proizvoda biljnog porijekla',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar prehrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-I-1513/08 od 14. 5. 2008.',
    LinkNaStudijskiProgram: <a href="http://ppf.unsa.ba/uploads/Dokumenti/studijski%20program%20PREHRAMBENE%20TEHNOLOGIJE%20BILJNOG%20PORIJEKLA-II%20ciklus-odsjek%20Prehrambene%20tehnologije.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Urbana poljoprivreda',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar urbane poljoprivrede',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '2019.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Poljoprivredne nauke',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor poljoprivrednih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-259/11 od 26. 1. 2011.  ',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Poljoprivredno-prehrambeni fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Prehrambene tehnologije',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor prehrambeno-tehnoloških nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-259/11 od 26. 1. 2011.  ',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Biologija - Biohemija i fiziologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor biologije - biohemija i fiziologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.-Vijeće PMF-a  29. 06.Odluka Senata br. 01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/biohemija-i-fiziologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Biologija - Ekologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor biologije - ekologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.-Vijeće PMF-a                   29. 06.Odluka Senata br. 01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/ekologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Biologija - Genetika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor biologije - genetike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.-Vijeće PMF-a  29. 06.Odluka Senata br. 01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/genetika" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Biologija - Mikrobiologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor biologije - mikrobiologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.-Vijeće PMF-a  29. 06.Odluka Senata br. 01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/mikrobiologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Biologija - Nastavnički',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor biologije - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.-Vijeće PMF-a  29. 06.Odluka Senata br. 01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/i-ciklus-studija/nastavnicki" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Fizika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor fizike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/I%20ciklus%20Opci%20smjer_41%20_F_.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Fizika u obrazovanju',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor fizike u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/I%20ciklus%20Fizika%20u%20obrazovanju_41%20_F_.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Fizika - Nastavnički 3 + 2',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor fizike - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Geografija - Nastavnički',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor geografije - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-nastavnicki/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Geografija - Regionalno i prostorno planiranje',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor geografije - regionalno i prostorno planiranje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-regionalno-i-prostorno-planiranje" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Geografija - Turizam i zaštita životne sredine',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor geografije  turizam i zaštita životne sredine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  41368',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/i-ciklus-studija/nastavni-programi-i-ciklusa/smjer-turizam-i-zastita-zivotne-sredine/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Hemija  Opći',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor hemije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  41368',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/opsti-smjer/9-uncategorised/780-inovirani-plan-i-program-i-ciklus-opsti-smjer-2" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Hemija  Nastavnički',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor hemije  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  41368  24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/nastavnicki-smjer/9-uncategorised/781-inovirani-plan-i-program-nastavnicki-smjer-i-ciklus-2" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Hemija  Kontrola kvaliteta i zaštita okoliša',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor hemije  kontrola kvaliteta i zaštita okoliša',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '41388  24.05.2017.  24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/i-ciklus/kontrola-kvaliteta-i-zastita-okolisa/9-uncategorised/782-plan-i-program-kontrola-kvaliteta-i-zastita-okolisa-i-ciklus-2" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Matematika  Opći smjer',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor matematike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/teorijska-matematika.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Matematika  Nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor matematike  nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/matematika-nastavni-smjer.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Matematika  Nastavnički smjer (matematika i informatika)',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor matematike  matematika i informatika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/matematika-i-informatika-nastavni-smjer.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Matematika  Teorijska kompjuterska nauka',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor matematike  softversko inženjerstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/teorijska-kompjuterska-nauka.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Matematika  Primijenjena matematika',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor matematike  primijenjena matematika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/dodiplomski-studij/primijenjena-matematika.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Konzervacija i restauracija  interdisciplinarni studij',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelor konzervacije i restauracije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013.',
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Biologija - Biohemija i fiziologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biologije - biohemija i fiziologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.  29. 06.  2016.  01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/biohemija-i-fiziologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Biologija - Ekologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biologije - ekologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.  29. 06. 2016.  01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/ekologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Biologija - Genetika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biologije - genetika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.  29. 06. 2016.   01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/genetika" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Biologija - Mikrobiologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biologije - mikrobiologija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.  29. 06. 2016.   01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/mikrobiologija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Biologija - Nastavnički',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar biologije - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  09.06.2016.  29. 06. 2016.   01-4474/16',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/ii-ciklus-studija/nastavnicki" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fizika',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar fizike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <div><a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Teorijska_fizika_41_F_.pdf" target="_blank"> LINK  </a> {'  |  '} <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Medicinska%20radijaciona%20fizika_41_F_.pdf" target="_blank"> LINK  </a> {'  |  '} <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus-Eksperimentalna%20fizika_41_F_.pdf" target="_blank"> LINK </a></div>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fizika u obrazovanju',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar fizike u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/npp/II%20ciklus%20-Fizika%20u%20obrazovanju_41_F_.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fizika u obrazovanju',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar fizike u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Geografija - Nastavnički',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar geografije - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/ii-ciklus-studija/nastavni-programi-ii-ciklusa/smjer-nastavnicki/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Geografija - Regionalno i prostorno planiranje',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar geografije - regionalno i prostorno planiranje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/ii-ciklus-studija/nastavni-programi-ii-ciklusa/smjer-regionalno-i-prostorno-planiranje/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Geografija - Turizam i zaštita životne sredine',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar geografije - turizam i zaštita životne sredine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/wp-content/uploads//NastavniplanoviIIciklus/Nastavni_plan_II_ciklus_turizam_i_zastita_zivotne_sredine.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Hemija - Opći',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar hemije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2009.  14.06.2012. i 29.06.2016.  24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/opsti-smjer" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Hemija - Nastavnički',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar hemije - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2009.  14.06.2012. i 29.06.2016.  24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/nastavnicki-smjer" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Hemija  Kontrola kvaliteta i zaštita okoliša',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar  hemije  kontrola kvaliteta i zaštita okoliša',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/ii-ciklus/kkzo" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Interdisciplinarni studij / sa ALU i Arhitektonskim fakultetom/ Konzervacija-restauracija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar konzervacije-restauracije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.05.2017.',
    LinkNaStudijskiProgram: <a href="-" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Matematika  Opći smjer',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar matematike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/opci-smjer.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Matematika  Nastavnički smjer',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar matematike - nastavnički smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/nastavnicki-smjer.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Matematika  Teorijska kompjuterska nauka',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar matematike - softversko inženjerstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/teorijska-kompjuterska-nauka.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Matematika - Primijenjena matematika',
    NacinRealizacijeNastave: 'Redovan, Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar matematike - primijenjena matematika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.09.2005.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/postdiplomski-studij/primijenjena-matematika.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Biologija - Biohemija i fiziologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor bioloških nauka u oblasti biohemije i fiziologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '10.07.2012.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Biologija - Ekologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor bioloških nauka u oblasti ekologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '10.07.2012.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Biologija - Genetika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor bioloških nauka u oblasti genetike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '10.07.2012.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Biologija - Mikrobiologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Dokrot bioloških nauka u oblasti mikrobiologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '10.07.2012.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/biologija/index.php/studijski-programi/iii-ciklus-studija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Zajednički doktorski studij Prirodne i matematičke nauke u obrazovanju - Biologija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor bioloških nauka u oblasti obrazovanja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: 'sept.2013..  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/prirodne-i-matematicke-nauke-u-obrazovanju" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Fizika - Teorijska fizika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor nauka fizike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.04.2013.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/images/IIIciklus/teorijska_fizika/Studijski%20program%20III%20CIKLUSA%20STUDIJA%20FIZIKE1.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Zajednički doktorski studij Prirodne i matematičke nauke u obrazovanju - Fizika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor nauka fizike u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: 'sept.2013..  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/fizika/index.php/bs/treci-ciklus" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Geografija - Regionalno i prostorno planiranje',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor geografskih nauka u oblasti regionalnog i prostornog planiranja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.04.2013.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/iii-ciklus-studija/nastavni-programi/smjer-regionalno-i-prostorno-planiranje/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Geografija - Turizam i zaštita životne sredine',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor geografskih nauka u oblasti turizma i zaštite životne sredine',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.04.2013.  27.01.2016.',
    LinkNaStudijskiProgram: <a href="http://pmf.unsa.ba/geografija/iii-ciklus-studija/nastavni-programi/smjer-turizam-i-zastita-zivotne-sredine/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Zajednički doktorski studij Prirodne i matematičke nauke u obrazovanju - Geografija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor geografskih nauka u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: 'sept.2013..  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/geografija/index.php/nastavniplanovipmfunsaiiiciklus/geografija-u-obrazovanju" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Zajednički doktorski studij Prirodne i matematičke nauke u obrazovanju - Hemija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor hemijskih nauka u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: 'sept.2013..  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/prirodne-i-matematicke-nauke-u-obrazovanju" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Hemija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor hemijskih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '10.07.2012.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://www.pmf.unsa.ba/hemija/index.php/bs/studijski-programi/iii-ciklus/hemija" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Matematičke nauke u Jugoistočnoj Evropi  Opći smjer',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor matematičkih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01.12.2010.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Matematičke nauke u Jugoistočnoj Evropi  Teorijska kompjuterska nauka',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor kompjuterskih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01.12.2010.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Matematičke nauke u Jugoistočnoj Evropi  Primijenjena matematika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor matematičkih nauka',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01.12.2010.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/matematicke-nauke-u-jugoistocnoj-evropi.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Prirodno-matematički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Zajednički doktorski studij Prirodne i matematičke nauke u obrazovanju- Matematika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor matematičkih nauka u obrazovanju',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01.12.2010.  04.05.2016.',
    LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/doktorski-studij/prirodne-i-matematicke-nauke-u-obrazovanju.html" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
        FakultetAkademija: 'Prirodno-matematički fakultet',
        CiklusStudija: 'Stručni studij',
        NazivStudijskogPrograma: 'Informacione tehnologije',
        NacinRealizacijeNastave: 'Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Stručni specijalista iz informacionih tehnologija',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '120',
        DatumSaglasnostiZaIzvodjenjeStudija: '2018.',
        LinkNaStudijskiProgram: <a href="http://math.pmf.unsa.ba/strucni-studij/informacione-tehnologije.html" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Šumarski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Šumarstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2398/17 od 29. 03. 2017.',
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20I%20ciklus/I%20ciklus%20sumarstvo%2020172018.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Šumarski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Hortikultura',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-5053/17 od 19. 07. 2017.',
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20I%20ciklus/I%20ciklus%20hortikultura%2020172018.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Šumarski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Održivo upravljanje šumskim ekosistemima',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar šumarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-2398/17od 29. 03. 2017.',
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20II%20ciklus/IIcik20172018sumarstvo.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Šumarski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Pejsažna arhitektura',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar hortikulture',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-5053/17 od 19. 07. 2017.',
    LinkNaStudijskiProgram: <a href="http://sfsa.unsa.ba/dokumenti/katalog%20II%20ciklus/IIcik20172018hortikultura.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Prirodno-matematičke i biotehničke nauke',
    FakultetAkademija: 'Šumarski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'III studija Šumarstvo i Hortikultura',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor biotehničkih nauka/znanosti u oblasti šumarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '0101-38-2379/13 od 17.07.2013.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Arhitektonski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Arhitektura i urbanizam',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor Inžinjer  arhitekture',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-6077/17 od 27.09.2017.',
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-i-ciklus.php" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Arhitektonski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Arhitektura i urbanizam',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar arhitekture Diplomirani inžinjer arhitekture',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-6078/17 od 27.09.2017.',
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-ii-ciklus.php" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Arhitektonski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Arhitektura i urbanizam',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Akademska titula i naučno zvanje Doktor tehničkih nauka iz oblasti  arhitekture i urbanizma',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-8165/17 od 29.11.2017.',
    LinkNaStudijskiProgram: <a href="http://af.unsa.ba/s-iii-ciklus.php" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Nastavni plan i program prvog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.  21.06.2006.  19.09.2007.  25.03.2009.  23.09.2009.  25.06.2014.  25.03.2015.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Nastavni plan i program prvog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.  21.06.2006.  19.09.2007.  25.03.2009.  23.09.2009.  25.06.2014.  25.03.2015.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Nastavni plan i program prvog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.  21.06.2006.  19.09.2007.  25.03.2009.  23.09.2009.  25.06.2014.  25.03.2015.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Nastavni plan i program prvog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.  21.06.2006.  19.09.2007.  25.03.2009.  23.09.2009.  25.06.2014.  25.03.2015.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=134" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Nastavni plan i program drugog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar elektrotehnike - Diplomirani inženjer elektrotehnike, odsjek  automatika i elektronika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.07.2007.  23.09.2009.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Nastavni plan i program drugog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar elektrotehnike -  Diplomirani inženjer elektrotehnike, odsjek elektroenergetika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.07.2007.  23.09.2009.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Nastavni plan i program drugog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar elektrotehnike -  Diplomirani inženjer elektrotehnike, odsjek  računarstvo i informatika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.07.2007.  23.09.2009.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Nastavni plan i program drugog ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar elektrotehnike -  Diplomirani inženjer elektrotehnike, odsjek telekomunikacije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.07.2007.  23.09.2009.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=135" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master program  Softver inženjering',
    NacinRealizacijeNastave: 'Vanredan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar diplomirani inženjer računarstva i informatike  softver inženjering',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.12.2016.  19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Nastavni plan i program trećeg ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti automatike i elektronike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2010.  25.02.2015.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Nastavni plan i program trećeg ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti elektoenergetike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.12.2016.  19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Nastavni plan i program trećeg ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti računarstva i informatike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.12.2016.  19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Elektrotehnički fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Nastavni plan i program trećeg ciklusa studija:',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti telekomunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.12.2016.  19.07.2017.',
    LinkNaStudijskiProgram: <a href="http://www.etf.unsa.ba/index.php?id=461" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
        FakultetAkademija: 'Elektrotehnički fakultet',
        CiklusStudija: 'Stručni studij',
        NazivStudijskogPrograma: 'Razvoj softvera',
        NacinRealizacijeNastave: 'Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Stručni specijalista za razvoj softvera',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '120',
        DatumSaglasnostiZaIzvodjenjeStudija: '2018.',
        LinkNaStudijskiProgram: <a href="https://rs.etf.unsa.ba/index.php?page=about_us&lang=bs" target="_blank"> LINK </a>
    },{
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje cestovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer cestovni saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2009.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje željeznički saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer željeznički saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2009.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje zrakoplovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer zrakoplovni saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2009.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje komunikacijske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer komunikacijske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2009.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje poštanske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer poštanske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.05.2009.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje kompjuterske i informacijske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'bakalaureat/bachelor inžinjer saobraćaja i komunikacija, smjer kompjuterske i informacijske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.03.2015.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje cestovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer cestovni saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje željeznički saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer željeznički saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek saobraćaj, usmjerenje zrakoplovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer zrakoplovni saobraćaj',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje komunikacijske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer komunikacijske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje poštanske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer poštanske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek komunikacije, usmjerenje kompjuterske i informacijske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'magistar saobraćaja i komunikacija - diplomirani inžinjer saobraćaja i komunikacija, smjer kompjuterske i informacijske tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '04.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Oblast cestovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'doktor tehničkih nauka/znanosti iz oblasti saobraćaja i komunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.07.2011.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Oblast željeznički saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'doktor tehničkih nauka/znanosti iz oblasti saobraćaja i komunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.07.2011.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Oblast zrakoplovni saobraćaj',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'doktor tehničkih nauka/znanosti iz oblasti saobraćaja i komunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.07.2011.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Oblast komunikacijske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'doktor tehničkih nauka/znanosti iz oblasti saobraćaja i komunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.07.2011.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Fakultet za saobraćaj i komunikacije',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Oblast poštanske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'doktor tehničkih nauka/znanosti iz oblasti saobraćaja i komunikacija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '20.07.2011.',
    LinkNaStudijskiProgram: <a href="https://www.fsk.unsa.ba/studijski-programi" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studij građevinarstva',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor građevinarstva - Inžinjer građevinarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006.  08.07.2009.  03.04.2013.  16.07.2014.',
    LinkNaStudijskiProgram: <a href="http://www.gf.unsa.ba/?lokacija=nastava" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studij geodezije i geoinformatike',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor geodezije i geoinformatike - Inžinjer geodezije i geoinformatike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180 ECTS',
    DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006. 08.07.2009.  03.04.2013.',
    LinkNaStudijskiProgram: ''
}, {
        GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
        FakultetAkademija: 'Građevinski fakultet',
        CiklusStudija: 'II',
        NazivStudijskogPrograma: 'Magistarski studij građevinarstva, smjer Konstrukcije',
        NacinRealizacijeNastave: 'Redovan',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar građevinarstva -Diplomirani inžinjer građevinarstva, smjer Konstrukcije',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '120',
        DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006. 08.07.2009.  16.07.2014.',
        LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Magistarski studij građevinarstva, smjer Konstrukcije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar građevinarstva -Diplomirani inžinjer građevinarstva, smjer Konstrukcije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006. 08.07.2009.  16.07.2014.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Geotehnika',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Diplomirani inženjer građevine - smjer geotehnika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '2019.',
    LinkNaStudijskiProgram:  <a href="http://gf.unsa.ba/brosura-geotehnika.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Magistarski studij građevinarstva, smjer Saobraćajnice',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar građevinarstva-Diplomirani inžinjer građevinarstva, smjer Saobraćajnice',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006.  08.07.2009.  16.07.2014.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Magistarski studij geodezije i geoinformatike',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar geodezije i geoinformatike - Diplomirani inžinjer geodezije i geoinformatike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '21.06.2006.   08.07.2009.  03.04.2013.  16.07.2014.  16.07.2014.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij, oblast građevinarstva',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti građevinarstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2009.  29.05.2013.  04.05.2016.  04.05.2016.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Građevinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Doktorski studij, oblast geodezije i geoinformatike',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti geodezije i geoinformatike',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2009.  29.05.2013.  30.09.2015.  27.09.2017.',
    LinkNaStudijskiProgram: ''
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Mašinski proizvodni inžinjering',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Mašinski proizvodni inžinjering',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MPI.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Industrijsko inženjerstvo i menadžment',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Industrijsko inžinjerstvo i menadžment',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Energetika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Energetika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Energetika.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Procesno inžinjerstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Procesno inžinjerstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProcesnoInzinjerstvo.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Klimatizacija, grijanje i hlađenje',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Klimatizacija, grijanje i hlađenje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/KGH.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Tehnologije drveta',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Tehnologije drveta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/TehnologijeDrveta.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Motori i vozila',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Motori i vozila',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MotoriIVozila.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odbrambene tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Odbrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Mašinske konstrukcije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/bachelor inžinjer mašinstva, smjer Mašinske konstrukcije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '22.09.2005.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Ma%C5%A1inskeKonstrukcije.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Proizvodne tehnologije, automatizacija i robotika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Proizvodne tehnologije, automatizacija i robotika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProizvodneTehnologijeAutomatizacijaRobotika.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Industrijsko inžinjerstvo i menadžment',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Industrijsko inžinjerstvo i menadžment',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Energetika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Energetika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Energetika_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Procesno inžinjerstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Procesno inžinjerstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/ProcesnoInzinjerstvo_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Klimatizacija, grijanje i hlađenje',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Klimatizacija, grijanje i hlađenje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/KGH_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Mašinske konstrukcije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Mašinske konstrukcije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MasinskeKonstrukcije_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Motori i vozila',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Motori i vozila',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MIV_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odbrambene tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Odbrambene tehnologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Tehnologije drveta',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar mašinstva  diplomirani inžinjer mašinstva, smjer Tehnologije drveta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '14.05.2008.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/TehnologijeDrveta_II.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Obnovljivi izvori energije i okolinske tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '02.11.2011.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Obnovljivi%20izvori%20energije%20i%20okolinske%20tehnologije_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Mašinske konstrukcije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2014/15',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Ma%C5%A1inskeKonstrukcije_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Razvoj savremenih motora i vozila',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2014/15',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/RazvojSavremenihMotoraIVozila_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odbrambene tehnologije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2014/15',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/OdbrambeneTehnologije_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Mehanika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '2014/15',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/Mehanika_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Mašinski proizvodni inženjering',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '42913',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/MPI_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Tehničke nauke',
    FakultetAkademija: 'Mašinski fakultet',
    CiklusStudija: 'III (Treći)',
    NazivStudijskogPrograma: 'Industrijsko inžinjerstvo i menadžment',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor tehničkih nauka/znanosti iz oblasti mašinstva',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '24.05.2017.',
    LinkNaStudijskiProgram: <a href="http://www.mef.unsa.ba/programStudija/IIM_III.aspx" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Nastavnički',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti - edukacija likovnih umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/nastavnicki/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Slikarstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti-slikarstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/slikarstvo/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Kiparstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti-kiparstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/kiparstvo/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Grafika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti-grafika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/grafika/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Grafički dizajn',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti-grafički dizajn',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/graficki-dizajn/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Produkt dizajn',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor likovne umjetnosti-produkt dizajn',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '23.12.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/produkt-dizajn/ciklus-i" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet u Sarajevu',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Interdisciplinarni studij konzervacija i restauracija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakalaureat/Bachelor  konzervacije i restauracije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '29.05.2013.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/interdisciplinarni-studijski-program-konzervacija-i-restauracija-i-ciklus" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Nastavnički',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti- edukacija likovnih umjetnosti',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/nastavnicki/ciklus-ii-nastavnicki" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Slikarstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti - slikarstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/slikarstvo/ciklus-ii" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Kiparstvo',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti  kiparstvo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/kiparstvo/ciklus-ii" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Grafika',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti  grafika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/grafika/ciklus-ii" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Grafički dizajn',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti grafički dizajn',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/graficki-dizajn/ciklus-ii" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Produkt dizajn',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti produkt dizajn',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/odsjek/produkt-dizajn/ciklus-ii" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Fotografija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar likovne umjetnosti - fotografija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '27.06.2012.',
    LinkNaStudijskiProgram: <a href="/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija likovnih umjetnosti , Prirodno-matematički fakultet i Arhitektonski fakultet  u Sarajevu',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Interdisciplinarni studij konzervacija i restauracija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar konzervacije i restauracije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '26.04.2017.',
    LinkNaStudijskiProgram: <a href="http://www.alu.unsa.ba/content/interdisciplinarni-studijski-program-konzervacija-i-restauracija-ii-ciklus" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program- Gluma',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelour scenskih umjetnosti- gluma',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-acting" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program - Režija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelour scenskih umjetnosit- Režija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program- Režija/Audiovizuelno usmjerenje: kamera, montaža, snimanje i dizajn zvuka',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelour audiovizuelnih umjetnosti- smimatelj;',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '42515',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing/av-usmjerenja" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program- Dramaturgija',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelour scenskih umjetnosti-dramaturgija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '42515',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-dramaturgy" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Studijski program- Produkcija i menadžment u oblasti scenskih umjetnosti',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bachelour scenskih umjetnosit- produkcija i menadžment',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-production" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Studijski program- Gluma MA',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar scenskih umjetnosti- gluma',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '42515',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-acting" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Studijski program-Režija MA',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar scenskih umjetnosti-režija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '41836',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-directing" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Studijski program-Dramaturgija MA',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar scenskih umjetnosti-dramaturgija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '25.05.2016.',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-dramaturgy" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Akademija scenskih umjetnosti',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Studijski program/Produkcija i menadžment u oblasti scenskih umjetnosti MS',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar scenskih umjetnosti-produkcija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '26.06.2013.',
    LinkNaStudijskiProgram: <a href="https://www.asu.unsa.ba/index.php/en/departments-studies/department-of-production" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za kompoziciju',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti - kompozicija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/Orkestarsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  orkestarsko dirigovanje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/Horsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  horsko dirigovanje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za solo pjevanje',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  solo pjevanje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Klavir',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  klavir',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Udaraljke',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  udaraljke',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Harfa',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  harfa',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Violina',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  violina',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Viola',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  viola',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Violončelo',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  violončelo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Kontrabas',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  kontrabas',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Gitara',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  gitara',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Flauta',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  flauta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Oboa',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  oboa',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Klarinet',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  klarinet',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Saksofon',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  saksofon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Fagot',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  fagot',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Truba',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  truba',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Trombon',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  trombon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Horna',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  horna',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Harmonika',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičkih umjetnosti  harmonika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/Muzikologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/Etnomuzikologija',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor etnomuzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'I',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Bakaleureat/Bachelor muzičke teorije i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '240',
    DatumSaglasnostiZaIzvodjenjeStudija: '40723',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/Nastavni%20plan%2C%20I%20ciklus%20studija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za kompoziciju',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti - kompozicija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/ Orkestarsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  orkestarsko dirigovanje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/ Horsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  horsko dirigovanje',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za solo pjevanje/Koncertni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  solo pjevanje, koncertni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za solo pjevanje/Operni smjer',
    NacinRealizacijeNastave: 'Redovan, Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  solo pjevanje, operni smjer',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za klavir,udaraljke, harfu i srodene instrumente/Klavir',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti - Klavir',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za klavir,udaraljke, harfu i srodene instrumente/Korepeticija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti - korepeticija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za klavir,udaraljke, harfu i srodene instrumente/Metodika klavira',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  metodika klavir',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za klavir,udaraljke, harfu i srodene instrumente/Udaraljke',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  udaraljke',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za klavir,udaraljke, harfu i srodene instrumente/Harfa',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  harfa',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/violina',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  violina',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/viola',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  viola',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/violončelo',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  violončelo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/kontrabas',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  kontrabas',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/gitara',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  gitara',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/flauta',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  flauta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/oboa',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  oboa',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/klarinet',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  klarinet',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/fagot',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  fagot',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/saksofon',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  saksofon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/truba',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  truba',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/trombon',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  trombon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/horna',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  horna',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/harmonika',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičkih umjetnosti  harmonika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/muzikologija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/etnomuzikologija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar etnomuzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju/solfeggio',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičke teorije i pedagogije - solfeggio',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju/harmonija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičke teorije i pedagogije - harmonija',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju/kontrapunkt',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičke teorije i pedagogije - kontrapunkt',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju/muzički oblici i stilovi',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičke teorije i pedagogije  muzički oblici i stilovi',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju/metodika muzičke nastave',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar muzičke teorije i pedagogije  metodika muzičke nastave',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '40738',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/NASTAVNI%20PLANOVI%20NA%20II.%20CIKLUSU%20STUDIJA.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za kompoziciju',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti kompozicije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/Orkestarsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti dirigovanja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za dirigovanje/Horsko dirigovanje',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti dirigovanja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za solo pjevanje',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti solo pjevanja',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Klavir',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti klavira',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Udaraljke',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti udaraljki',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za klavir, udaraljke, harfu i srodne instrumente / Harfa',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti harfe',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Violina',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti gudačkih instrumenata  Violina',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Viola',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti gudačkih instrumenata  Viola',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Violončelo',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti gudačkih instrumenata  Violončelo',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Kontrabas',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti gudačkih instrumenata  Kontrabas',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za gudačke instrumente i gitaru/ Gitara',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti  Gitara',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Flauta',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Flauta',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Oboa',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Oboa',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Klarinet',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Klarinet',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Saksofon',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Saksofon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Fagot',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Fagot',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Truba',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Truba',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Trombon',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Trombon',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Horna',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti iz oblasti duvačkih instrumenata  Horna',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za duvačke instrumente i harmoniku/ Harmonika',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih umjetnosti - Harmonika',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/Muzikologija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih nauka iz oblasti muzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za muzikologiju i etnomuzikologiju/Etnomuzikologija',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih nauka iz oblasti etnomuzikologije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'Umjetnost',
    FakultetAkademija: 'Muzička akademija',
    CiklusStudija: 'III',
    NazivStudijskogPrograma: 'Odsjek za muzičku teoriju i pedagogiju',
    NacinRealizacijeNastave: 'Redovan samofinansirajući',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor muzičkih nauka iz oblasti muzičke teorije i pedagogije',
    JezikStudija: 'Bosanski, hrvatski, srpski   ',
    TrajanjeCiklusaStudijaECTS: '180',
    DatumSaglasnostiZaIzvodjenjeStudija: '40331',
    LinkNaStudijskiProgram: <a href="http://www.mas.unsa.ba/sites/default/files/dokumenti/treciciklusstudija.pdf" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Demokratija i ljudska prava u jugoistočnoj Evropi',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar ljudskih prava i demokratije',
    JezikStudija: 'engleski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1710/09 od 08.07.2009.;  01-3098/17 od 26.04.2017.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/erma-2/" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'UNSA',
        FakultetAkademija: 'Centar za interdisciplinarne studije',
        CiklusStudija: 'II',
        NazivStudijskogPrograma: 'Međunarodna i regionalna sigurnost',
        NacinRealizacijeNastave: 'Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar međunarodne i regionalne sigurnosti',
        JezikStudija: 'Bosanski, hrvatski, srpski   ',
        TrajanjeCiklusaStudijaECTS: '60',
        DatumSaglasnostiZaIzvodjenjeStudija: '2018.',
        LinkNaStudijskiProgram: <a href="https://cis.unsa.ba/bhs/medunarodna-i-regionalna-sigurnost/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Evropske studije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar evropskih studija',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '120 i 60',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1962/10 od 14.07.2010.;  01-3099/17 od 26.04.2017.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/evropske-studije/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Upravljanje državom i nevladinim organizacijama',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar upravljanja državom i nevladinim organizacijama',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-3206-3/09 od 23.12.2009.;   01-4051/15 od 24.06.2015.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/upravljanje-drzavom-i-nevladinim-organizacijama/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Rodne studije',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar rodnih studija',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-38-1224/10 od 28. 04.2010.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/rodne-studije/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Jedinstveno zdravlje',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar jedinstvenog zdravlja',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '60',
    DatumSaglasnostiZaIzvodjenjeStudija: '28.10.2015.   0101-85-1/16',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/programi/magistarski/jedinstveno-zdravlje/" target="_blank"> LINK </a>
}, {
    GrupacijaNaukaUmjetnosti: 'UNSA',
    FakultetAkademija: 'Centar za interdisciplinarne studije',
    CiklusStudija: 'II',
    NazivStudijskogPrograma: 'Master studij Nutricionizam',
    NacinRealizacijeNastave: 'Redovan',
    NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar nutricionizma',
    JezikStudija: 'Bosanski, hrvatski, srpski  i engleski',
    TrajanjeCiklusaStudijaECTS: '120',
    DatumSaglasnostiZaIzvodjenjeStudija: '01-3096/17 od 26.04.2017.',
    LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/nutrition/" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'UNSA',
        FakultetAkademija: 'Centar za interdisciplinarne studije',
        CiklusStudija: 'II',
        NazivStudijskogPrograma: 'Master studij Međunarodna i regionalna sigurnost',
        NacinRealizacijeNastave: 'Redovan',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar međunarodne i regionalne sigurnosti',
        JezikStudija: 'engleski ',
        TrajanjeCiklusaStudijaECTS: '60',
        DatumSaglasnostiZaIzvodjenjeStudija: '28.03.2018.',
        LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/medunarodna-i-regionalna-sigurnost/" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'UNSA',
        FakultetAkademija: 'Centar za interdisciplinarne studije',
        CiklusStudija: 'II',
        NazivStudijskogPrograma: 'Master studij Zaštita od prirodnih katastrofa',
        NacinRealizacijeNastave: 'Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Magistar zaštite od prirodnih katastrofa',
        JezikStudija: 'engleski',
        TrajanjeCiklusaStudijaECTS: '60',
        DatumSaglasnostiZaIzvodjenjeStudija: '25.04.2018.',
        LinkNaStudijskiProgram: <a href="http://cis.unsa.ba/bs/zastita-od-prirodnih-katastrofa/" target="_blank"> LINK </a>
}, {
        GrupacijaNaukaUmjetnosti: 'UNSA',
        FakultetAkademija: 'Centar za interdisciplinarne studije',
        CiklusStudija: 'III',
        NazivStudijskogPrograma: 'Globalne studije',
        NacinRealizacijeNastave: 'Redovan samofinansirajući',
        NazivKvalifikacijeIOdgovarajucaTitula: 'Doktor interdisciplinarnih društvenih nauka',
        JezikStudija: 'Bosanski, hrvatski, srpski',
        TrajanjeCiklusaStudijaECTS: '180',
        DatumSaglasnostiZaIzvodjenjeStudija: '2019.',
        LinkNaStudijskiProgram: <a href="https://cis.unsa.ba/bhs/programi/doktorski/doktorski-studij-globalne-studije/" target="_blank"> LINK </a>
    }
];



// WEBPACK FOOTER //
// ./src/podaci.js